<!--
* UI Name: Add/Copy/Edit Workflow Group
* PIC: 213960
* Modify Date: 2022/10/15
-->
<template>
  <v-card
    class="v-modal-new-window analyzed-dialog analyzed-view-dialog process-detail-panel process-list-container"
  >
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>
      {{ title }}
    </v-card-title>
    <!-- [S]  Section detail-->
    <v-card-text class="user-data-section">
      <v-form ref="form" style="margin-top: -20px">
        <v-row v-if="!this.options.trans" class="no-gutters parnert-card-title pb-1">
          <v-col cols="12" class="pr-0 pt-0 pb-0 pr-1"> </v-col>
        </v-row>
        <v-row v-if="this.options.trans" class="no-gutters parnert-card-title">
          <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0 process-text-info">
            {{ $t('lbl.processSetup.addProcess.partner') }}
            <span>{{ this.options.trans ? this.options.trans.recipientId : '' }}</span>
          </v-col>
          <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0 process-text-info">
            {{ $t('lbl.processSetup.addProcess.direction') }}
            <span>{{ formData.procDirCd === 'O' ? 'Outbound' : 'Inbound' }}</span>
          </v-col>
        </v-row>
        <!-- //04/09/2021 203737 SPKA-63 issue 34 Modify the alignment of the text field and combo box for workflow -->
        <v-row v-if="!this.options.trans" class="ma-0">
          <v-col class="custom-form-control custom-figma-1 pb-0 pt-0 mt-0 pr-0" cols="12" lg="12">
            <v-row>
              <v-col
                class="comm-header-col data-query-section custom-figma-1 pb-0 pt-0 mt-0"
                cols="12"
                lg="9"
                md="9"
              >
                <v-row class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1">
                  <v-col cols="12" sm="3" class="pb-0 pt-0 pl-0">
                    <div class="pl-0 pt-0 pb-0">
                      <v-text-field
                        v-model="formData.procNm"
                        :rules="rules.procNm"
                        :disabled="!$auth.manage"
                        :label="$t('lbl.processSetup.addProcess.findbyName')"
                        ref="procNm"
                        dense
                        filled
                        @blur="validateWorkflowName()"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <!-- 05/17/2021 203737 SPKA-108 issue 60 Modify to display the company combo in popup when only comp_info.sp_flag = 'Y' -->
                  <v-col
                    v-show="$cookies.get('user-admin-yn') === 'Y'"
                    cols="12"
                    sm="2"
                    class="pt-0"
                  >
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.compId"
                        :menu-props="{ offsetY: true }"
                        :items="compList"
                        :rules="rules.compId"
                        :disabled="!$auth.manage"
                        :label="$t('lbl.common.conditionSearch.selectCompany')"
                        ref="compId"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="7" class="pt-3">
                    <span :style="$vuetify.theme.dark ? '' : 'color: red'"
                      >{{ $t('lbl.workflowGroup.componentNotUse') }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row> </v-row>
        <div class="d-flex">
          <div class="proc-icon-container">
            <v-tooltip v-if="authCompList.COM.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="addComponentPK('COM')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-comm drag-drawflow"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'COM')"
                >
                  <icon-svg :disabled="!$auth.manage" :size="procIconSize" iconName="proc-comm" />
                </v-btn>
              </template>
              <span>Connector</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.MAP.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="addComponentPK('MAP')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-mapper"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  ref="btnAddMap"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'MAP')"
                >
                  <icon-svg :disabled="!$auth.manage" :size="procIconSize" iconName="proc-mapper" />
                </v-btn>
              </template>
              <span>Mapper</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.CVT.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="addComponentPK('CVT')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-converter"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'CVT')"
                >
                  <icon-svg
                    :disabled="!$auth.manage"
                    :size="procIconSize"
                    iconName="proc-converter"
                  />
                </v-btn>
              </template>
              <span>Converter</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.USR.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="addComponentPK('USR')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-ucr"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'USR')"
                >
                  <icon-svg :disabled="!$auth.manage" :size="procIconSize" iconName="proc-usr" />
                </v-btn>
              </template>
              <span>User</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.DBA.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="isAgent"
                  @click="addComponentPK('DBA')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-dsm"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'DBA')"
                >
                  <icon-svg :disabled="!$auth.manage" :size="procIconSize" iconName="proc-dsm" />
                </v-btn>
              </template>
              <span>DB Adapter</span>
            </v-tooltip>
          </div>

          <div id="drawtest">
            <!-- <div class="expand-collapse">
              <a class="expand-collapse-text mr-3" @click="collapse(false)">{{
                $t("lbl.processSetup.addProcess.expandAll")
              }}</a>
              <a
                class="expand-collapse-text mr-3"
                style="font-size: 20px; text-decoration: none"
                >|</a
              >
              <a class="expand-collapse-text" @click="collapse(true)">{{
                $t("lbl.processSetup.addProcess.collapseAll")
              }}</a>
            </div> -->
            <div id="drawflow" @drop="drop($event)" @dragover="allowDrop($event)">
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
            </div>
            <v-menu
              v-model="showMenuFile"
              :position-x="x"
              :position-y="y"
              absolute
              offset-y
              content-class="file-menu-context drawflow-menu-custome"
            >
              <v-list-item
                v-for="(item, i) in contextsFile"
                :key="i"
                @click="fileMenuAction($event, item)"
              >
                <v-btn
                  :class="['mr-2 proc-button-style', item.icon]"
                  x-small
                  height="30"
                  width="30"
                >
                  <icon-svg :size="procIconSize" :iconName="item.icon"/></v-btn
                ><label>{{ item.text }}</label>
              </v-list-item>
            </v-menu>
          </div>
        </div>
        <!-- [E]  Section detail-->
        <!-- [S]  Button Control-->

        <!-- /**
           * 2021.08.11 203737 SPKA-183 issue 119 Change button function in Workflow Detail screen
        */-->
        <v-divider class="ml-0 mr-0 mt-4 mb-2 divder-popup" inset></v-divider>
        <v-row v-if="!this.options.trans" class="btn-form-control">
          <v-col cols="10" class="text-left pb-0 pt-0 pl-0">
            <v-btn
              @click="save((applyStatus = 'S'))"
              :disabled="!$auth.manage"
              class="btn btn-search primary btn-popup"
              >{{ $t('btn.common.save') }}</v-btn
            >
          </v-col>
          <v-col cols="2" class="text-right pb-0 pt-0">
            <v-btn class="btn btn-close btn-popup" @click="closeWindow('btn-close')">{{
              $t('btn.common.close')
            }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="this.options.trans" class="btn-form-control">
          <v-col cols="10" class="text-left pb-0 pt-0"></v-col>
          <v-col cols="2" class="text-right pb-0 pt-0">
            <v-btn class="btn btn-close btn-popup" @click="closeWindow('btn-close')">{{
              $t('btn.common.close')
            }}</v-btn>
          </v-col>
        </v-row>
        <!-- [E]  Button Control-->
      </v-form>
      <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
        <!-- // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function -->
        <Folder-List-Dialog
          v-if="dialog.type == 'folderList'"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialogPopup"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :foldList="foldList"
          :nodeId="nodeDir"
          :comId="foldId"
          @queryLeftList="queryLeftList()"
          @selectPathFolder="selectPathFolder($event)"
          class="load-file-dialog"
        ></Folder-List-Dialog>
        <ProcessApplyHistory
          v-if="dialog.type == 'ProcessApplyHistory'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
          @save-history="setCommentHistory"
        ></ProcessApplyHistory>
        <DelHistoryWorkflowDialog
          v-if="dialog.type == 'DelHistoryWorkflowDialog'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
          compNm="Folder Name"
        ></DelHistoryWorkflowDialog>
        <mapper-version-dialog
          v-if="dialog.type == 'mapperVersion'"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :reFreshList="refreshMapComp"
          :closeWFAndMoveMapBuilder="closeWFAndMoveMapBuilder"
          :versionList="flatFileVersionHistoryItem"
          :options="dialog.options"
          class="custom-dialog mapper-version"
        ></mapper-version-dialog>
        <addSqlGroup
          v-if="dialog.type == 'addSqlGroup'"
          class="maplist-layout-dialog add-code-dialog"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :types="searchTypeDBList"
          @refreshData="getGroupList($event)"
        ></addSqlGroup>
        <addD2DSqlGroup
          v-if="dialog.type == 'addD2DSqlGroup'"
          class="maplist-layout-dialog add-code-dialog"
          :id="dialog.id"
          :ref="'dialog-' + dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :types="searchTypeDBList"
          @refreshData="getGroupList($event)"
          style="width: 1300px !important"
        ></addD2DSqlGroup>
        <xmlMapperList
          v-if="dialog.type == 'xmlMapperList'"
          :id="dialog.id"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          @openDBMapperVersion="openDBMapperVersion($event)"
          class="maplist-layout-dialog"
          ref="xmlMapperList"
        >
        </xmlMapperList>
        <dbMapperVersionHistory
          v-if="dialog.type == 'dbMapperVersionHistory'"
          class="custom-dialog mapper-version"
          @viewFileMoveDBMapBuilder="viewFileMoveDBMapBuilder($event)"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
        ></dbMapperVersionHistory>
        <userVersionHistory
          v-if="dialog.type == 'userVersionHistory'"
          class="custom-dialog mapper-version"
          @openDeployUserComp="openDeployUserComp($event)"
          @viewFileMoveUserCompSim="viewFileMoveUserCompSim($event)"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
        ></userVersionHistory>
        <communicationRightLayer
          ref="communicationRightLayer"
          v-if="dialog.type == 'communicationRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.COM.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></communicationRightLayer>
        <mapperRightLayer
          ref="mapperRightLayer"
          v-if="dialog.type == 'mapperRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.MAP.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></mapperRightLayer>
        <userRightLayer
          ref="userRightLayer"
          v-if="dialog.type == 'userRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.USR.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></userRightLayer>

        <converterRightLayer
          ref="converterRightLayer"
          v-if="dialog.type == 'converterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.CVT.manage"
          :manageDBB="authCompList.DBB.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></converterRightLayer>
        <dbAdapterRightLayer
          ref="dbAdapterRightLayer"
          v-if="dialog.type == 'dbAdapterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :manage="authCompList.DBA.manage"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important; height: 100%"
        ></dbAdapterRightLayer>
      </div>
    </v-card-text>

    <dialogWindow
      ref="AlertProcessSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="alertProcSetupClose()"
    ></dialogWindow>
    <dialogWindow
      ref="RegisteredProcessSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Workflow Group', 'created'])"
      color="success"
      @select-ok="alertProcSetupClose()"
    ></dialogWindow>
    <dialogWindow
      ref="ModifyProcessSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Workflow Group', 'modified'])"
      color="success"
      @select-ok="alertProcSetupClose()"
    ></dialogWindow>
    <dialogWindow
      ref="AlertConverterCheckbox"
      size="max"
      :detail="messageValidate"
      color="warning"
      @select-ok="closeValidateDialog"
    ></dialogWindow>
    <dialogWindow
      ref="AlertAddDirComponent"
      size="max"
      :detail="alertMessage"
      color="warning"
      @select-ok="focusAddDirBtn"
    ></dialogWindow>
    <dialogWindow
      ref="CopyDone"
      size="max"
      :detail="$t('msg.common.success.copy')"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="checkSRCDST"
      size="max"
      :detail="messageValidate"
      color="warning"
      @select-ok="closeValidateDialog"
    ></dialogWindow>
  </v-card>
</template>

<script>
import procComm from '@/vue-caas/views/processnew/component/IconCommunication.vue';
import procMapper from '@/vue-caas/views/processnew/component/IconMapper.vue';
import procFilter from '@/vue-caas/views/processnew/component/IconFilter.vue';
import procConverter from '@/vue-caas/views/processnew/component/IconConverter.vue';
import procDir from '@/vue-caas/views/processnew/component/IconDir.vue';
import procDBAdapter from '@/vue-caas/views/processnew/component/IconDBAdapter.vue';
import procUser from '@/vue-caas/views/processnew/component/IconUser.vue';
import procTrig from '@/vue-caas/views/processnew/component/IconTrigger.vue';

import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
// import { Drag, Drop } from "vue-drag-drop";
import { mapState } from 'vuex';
import validationUtils from '@/vue-caas/utils/validationUtils';
import Drawflow from 'drawflow';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import store from '@/store';
import styleDrawflow from 'drawflow/dist/drawflow.min.css'; // eslint-disable-line no-use-before-define
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

import AddPartnerLayout from '@/vue-caas/views/partner/PartnerAdd.vue';
// import addIdentificationinDialog from "@/vue-caas/views/ediid/AddIdentification.vue";
// 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
import FolderListDialog from '@/vue-caas/views/folder/FolderListDialog.vue';
import ProcessApplyHistory from '@/vue-caas/views/process/ProcessApplyHistory.vue';
import DelHistoryWorkflowDialog from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';

import mapperVersionDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue';
import userVersionHistory from '@/vue-caas/views/usercomp/UserComponentVersionHistory.vue';
// import idb from '@/vue-dlb/utils/idb';

// 2021.8.9 203728 need waiting when save
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';

import $ from 'jquery';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import addSqlGroup from '@/vue-caas/views/dbadapter/AddSqlGroup.vue';
import addD2DSqlGroup from '@/vue-caas/views/dbadapter/AddD2DSqlGroup.vue';
import xmlMapperList from '@/vue-caas/views/dbadapter/DBMapperList.vue';
import dbMapperVersionHistory from '@/vue-caas/views/dbadapter/DBMapperVersionHistory.vue';
import communicationRightLayer from '@/vue-caas/views/processnew/rightlayer/CommunicationRightLayer.vue';
import filterRightLayer from '@/vue-caas/views/processnew/rightlayer/FilterRightLayer.vue';
import mapperRightLayer from '@/vue-caas/views/processnew/rightlayer/MapperRightLayer.vue';
import triggerRightLayer from '@/vue-caas/views/processnew/rightlayer/TriggerRightLayer.vue';
import userRightLayer from '@/vue-caas/views/processnew/rightlayer/UserRightLayer.vue';
import folderRightLayer from '@/vue-caas/views/processnew/rightlayer/FolderRightLayer.vue';
import converterRightLayer from '@/vue-caas/views/processnew/rightlayer/ConverterRightLayer.vue';
import router from '@/router/index.js';

function getType(id) {
  let output = $(`#node-${id}`).attr('class');
  return output.replace(/[a-z -]/g, '');
}

function getOutNode(str, nodeIn) {
  return str
    .replace('connection node_in_node-', '')
    .replace(`node_out_node-${nodeIn} output_1 input_1`, '');
}

export default {
  components: {
    dialogWindow,
    // AddPartnerLayout,
    // addIdentificationinDialog,
    // Drag,
    FolderListDialog,
    ProcessApplyHistory,
    DelHistoryWorkflowDialog,
    mapperVersionDialog,
    IconSvg,
    SystemProgress,
    addSqlGroup,
    addD2DSqlGroup,
    xmlMapperList,
    dbMapperVersionHistory,
    userVersionHistory,
    communicationRightLayer,
    // filterRightLayer,
    mapperRightLayer,
    // triggerRightLayer,
    userRightLayer,
    converterRightLayer,
    // folderRightLayer,
  },
  procComm,
  procFilter,
  // procFolder,
  // procSet,
  procConverter,
  // procEnveloper,
  procMapper,
  procDir,
  procUser,
  // procTrig,
  // Drag,
  // Drop,
  name: 'process-detail-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd','flatFile', 'dataValue'],
  data() {
    return {
      isLoading: false,
      detailDialog: false,
      action: 'insert',
      procComs: [],
      prnrList: [],
      searchTypeDBList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'select', value: 'select' },
        { text: 'insert', value: 'insert' },
        { text: 'update', value: 'update' },
        { text: 'delete', value: 'delete' },
      ],
      boundList: [
        { text: 'Inbound', value: 'I' },
        { text: 'Outbound', value: 'O' },
      ],
      showMenuFile: false,
      x: 0,
      y: 0,
      contextsFile: [],
      editor: null,
      formData: {
        procId: '',
        procNm: '',
        compId: '',
        senderId: '',
        receiverId: '',
        procDirCd: '',
        procComList: [],
        selSenderId: '',
        selReceiverId: '',
        qlfrSenderEdiId: '',
        qlfrReceiverEdiId: '',
        comEdiNm: '',
        receiverEdiNm: '',
        senderEdiNm: '',
        comEdiId: '',
        senderEdiIdKey: '',
        receiverEdiIdKey: '',
        timeResponse: 0,
      },
      rules: {
        procNm: [
          (v) => !!v || 'Process Name is required',
          (v) => !v || v.length <= 50 || 'Partner Name max length is 50.',
        ],
        compId: [(v) => !!v || 'Company is required'],
        senderId: [
          (v) => !!v || 'Sender is required',
          (v) =>
            !(v === this.formData.receiverId && v !== '*') ||
            'Sender and Receiver must be different',
        ],
        receiverId: [
          (v) => !!v || 'Receiver is required',
          (v) =>
            !(v === this.formData.senderId && v !== '*') || 'Sender and Receiver must be different',
        ],
        procDirCd: [(v) => !!v || 'Process direction is required'],
        selSenderId: [(v) => !!v || 'Sender Identifier is required'],
        selReceiverId: [(v) => !!v || 'Receiver Identifier is required'],
      },
      formHasErrors: false,
      procComsColor: '',
      checkDialogColor: 'error',
      checkDialogInfo: '',
      title: '',
      options: '',
      replacePattern: [],
      nodeId: '',
      resetConverId: '',
      messageValidate: '',
      focusField: '',
      focusConverter: '',
      arrProc: [],
      loadArrProc: [],
      selectedNode: '',
      haveDir: false,
      mappers: [],
      senders: [],
      recipients: [],
      mapperContracts: [],
      listSender: [],
      listRecipient: [],
      selSenderId: {
        id: '',
      },
      selReceiverId: {
        id: '',
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      idenType: 0,
      // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
      leftItems: {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: '',
          },
        ],
      },
      nodeDir: '',
      foldId: '',
      indexRoute: 0,
      alertMessage: '',
      focusDirIcon: true,
      currVersionNo: 0.1,
      applyCmt: '',
      apply_sts: '',
      // 2021.9.10 203728 SPKA-208 add Test/Live indicator
      processType: '',
      flatFileVersionHistoryItem: null,
      // 2021.10.19 203728 SPKA-224 add list params
      fltrTpCdList: [],
      cvtrTpCdList: [],
      protocolList: [],
      onSave: false,
      procIconSize: 16,
      isAgent: false,
      nodesSelected: [],
      processViewArr: [],
      isClick: true,
      usedMapList: [],
      compTpNmList: [
        { text: 'Connector', value: 'COM' },
        { text: 'Filter', value: 'FLT' },
        { text: 'Folder', value: 'DIR' },
        { text: 'Mapper', value: 'MAP' },
        { text: 'Converter', value: 'CVT' },
        { text: 'User', value: 'USR' },
        { text: 'Trigger', value: 'TRIG' },
        { text: 'Group', value: 'GRP' },
        { text: 'DBAdapter', value: 'DBA' },
        { text: 'DBAdapter', value: 'DBAC' },
      ],
      rightLayerNmList: [
        { text: 'communicationRightLayer', value: 'COM' },
        { text: 'filterRightLayer', value: 'FLT' },
        { text: 'folderRightLayer', value: 'DIR' },
        { text: 'mapperRightLayer', value: 'MAP' },
        { text: 'converterRightLayer', value: 'CVT' },
        { text: 'userRightLayer', value: 'USR' },
        { text: 'triggerRightLayer', value: 'TRIG' },
        { text: 'groupRightLayer', value: 'GRP' },
        { text: 'dbAdapterRightLayer', value: 'DBA' },
        { text: 'dbAdapterRightLayer', value: 'DBAC' },
      ],
      authCompList: {
        COM: { manage: false },
        FLT: { manage: false },
        DIR: { manage: false },
        MAP: { manage: false },
        CVT: { manage: false },
        AI: { manage: false },
        USR: { manage: false },
        TRIG: { manage: true },
        GRP: { manage: false },
        DBA: { manage: false },
        DBB: { manage: false },
      },
    };
  },

  watch: {
    detailDialog() {
      // 팝업이 열리면 드랍다운 메뉴가 닫히지 않도록 close가 되지 않도록 하는 로직 추가
      // 팝업 컨텐츠를 드래그할 경우 팝업이 닫히는 문제를 해결하기 위해
      // 상위 컴포넌트에서 컴포넌트 선언 시 이 이벤트를 받지 않으면, 여기서 발생시킨 이벤트는 버려짐
      this.detailDialog ? this.$emit('disable-close') : this.$emit('enable-close');
      this.initialize();

      this.$emit('close-dialog');
    },
    'formData.senderId'() {
      if (this.formData.senderId && this.selSenderId && this.selSenderId.id !== '') {
        this.selSenderId = { id: '' };
        // 2021.10.29 203728 SPKA-240 add comEdiIdKey, prEdiIdKey
        this.formData.senderEdiIdKey = '';
        this.formData.selSenderId = '';
        if (this.mappers[0]) {
          this.mappers[0].info[0].sender = '';
        }
      }
    },
    'formData.receiverId'() {
      if (this.formData.receiverId && this.selReceiverId && this.selReceiverId.id !== '') {
        this.selReceiverId = { id: '' };
        // 2021.10.29 203728 SPKA-240 add comEdiIdKey, prEdiIdKey
        this.formData.receiverEdiIdKey = '';
        this.formData.selReceiverId = '';
        if (this.mappers[0]) {
          this.mappers[0].info[0].recipient = '';
        }
      }
    },
  },

  computed: {
    getValue() {
      return this.value;
    },
    getPrnrList() {
      return this.prnrList;
    },
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    communicationList() {
      return this.$store.getters.communicationSelectBoxList;
    },
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
    converterList() {
      return this.$store.getters.dataSelectBox;
    },
    dbAdapterListHaveChild() {
      return this.$store.getters.dataDBASelectBox;
    },
    dbAdapterList() {
      let data = [];
      this.$store.getters.dataDBASelectBox.forEach((tmpDba) => {
        if (tmpDba.dba_type !== 'D2D' || tmpDba.dba_id === tmpDba.dba_child_id) {
          data.push(tmpDba);
        }
      });
      return data;
    },
    userList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
    triggerList() {
      return this.$store.getters.triggerSelectBoxList;
    },
    workflowGroupList() {
      return this.$store.getters.workflowGroupSelectBoxList;
    },
    compList() {
      let compList = [];
      const tmpCompList = this.$store.getters.companiesForSetup;
      for (let i = 0; i < tmpCompList.length; i += 1) {
        const tmpComp = tmpCompList[i];
        const tmp = { text: tmpComp.compNm, value: tmpComp.compId };
        compList.push(tmp);
      }
      // if (this.$cookies.get('ownr-id') === this.$cookies.get('comp-id')) {
      //   compList.unshift({ text: '*', value: '*' });
      // }
      return compList;
    },
    dbBrokerSelectBoxList() {
      return this.$store.getters.dbBrokerSelectBoxList;
    },
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
  },
  async created() {
    const componentRouters = router.options.routes.filter((e) => e.meta && e.meta.compCd);
    const menuAuth = JSON.parse(this.$cookies.get('menu-auth'));
    componentRouters.forEach((route) => {
      const index = menuAuth.find((e) => e.h === route.path);
      if (index) {
        this.authCompList[route.meta.compCd].manage = index.m;
      }
    });
    this.$auth.manage = true;
    this.isAgent = cfg.isAgent;
    // 05/04/2021 203737 issue 48 SPKA-96 Modify to not change the lightn version when refresh
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.options = param['options'];
    this.title = param['type'] + ' WorkFlow Group';
    // 2021.9.10 203728 SPKA-208 add Test/Live indicator
    this.processType = param['type'];
    let currVersionNo = this.options.versionNo;
    if (currVersionNo) {
      this.currVersionNo = currVersionNo;
    }

    // 2021.10.20 203728 get some list from parent
    this.fltrTpCdList = param['fltrTpCdList'];
    this.cvtrTpCdList = param['cvtrTpCdList'];
    this.protocolList = param['protocolList'];

    this.apply_sts = this.options.applyStatus;

    EventBus.$on('set-comp-id', this.clickHandler);
    EventBus.$on('set-comp-info', this.emitComInfo);
    EventBus.$on('open-right-layer', this.openRightLayer);
    // 2021.10.7 203728 not use
    // EventBus.$on('setReplacePattern',this.setReplacePattern);
    EventBus.$on('checkForCreateConverter', this.checkForCreateConverter);
    EventBus.$on('close', this.delNodeComponent);
    EventBus.$on('collapse', this.updateConnections);
    EventBus.$on('set-dir-path', this.setDirPath);
    EventBus.$on('set-map-contract', this.setInfoContract);
    EventBus.$on('remove-map-contract', this.removeMapAfterChangeSelectMap);
    // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
    EventBus.$on('openFolderList', this.openFolderList);
    EventBus.$on('open-map-version', this.openMapperVersion);
    // 2021.10.19 203728 SPKA-224 refresh component list data & call data DIR before initialize
    EventBus.$on('refresh-list-component', this.refreshComponent);
    // 2021.10.26 203728 SPKA-224 add method open history
    EventBus.$on('openDelHistoryWorkflowDialog', this.openDelHistoryWorkflowDialog);
    EventBus.$on('open-user-component-version', this.openUserComponentVersion);

    EventBus.$on('create-dba-child', this.createDBAChild);
    EventBus.$on('open-dialog-modify-d2d', this.openModifyD2DSQLGroup);
    EventBus.$on('open-dialog-modify', this.openModifySQLGroup);
    EventBus.$on('remove-dialog-add', this.removeDialog);
    EventBus.$on('openXmlMapperListDialog', this.openXmlMapperListDialog);
    EventBus.$on('copyContent', this.copyContent);
    EventBus.$on('delete-item', this.onDeleteItem);
    this.queryLeftList();
    await this.initialize();
  },
  destroyed() {
    EventBus.$on('set-comp-id', this.clickHandler);
    EventBus.$on('set-comp-info', this.emitComInfo);
    EventBus.$on('open-right-layer', this.openRightLayer);
    // 2021.10.7 203728 not use
    // EventBus.$on('setReplacePattern',this.setReplacePattern);
    EventBus.$on('checkForCreateConverter', this.checkForCreateConverter);
    EventBus.$on('close', this.delNodeComponent);
    EventBus.$on('set-dir-path', this.setDirPath);
    EventBus.$on('set-map-contract', this.setInfoContract);
    EventBus.$on('remove-map-contract', this.removeMapAfterChangeSelectMap);
    EventBus.$on('openFolderList', this.openFolderList);
    EventBus.$on('open-map-version', this.openMapperVersion);
    // 2021.10.19 203728 SPKA-224 refresh component list data
    EventBus.$on('refresh-list-component', this.refreshComponent);
    // 2021.10.26 203728 SPKA-224 add method open history
    EventBus.$on('openDelHistoryWorkflowDialog', this.openDelHistoryWorkflowDialog);
    EventBus.$on('open-user-component-version', this.openUserComponentVersion);
    EventBus.$on('copyContent', this.copyContent);
  },
  // 2122.03.29 SPKA-421 Add spinner when loading Edit Workflow popup
  methods: {
    validateWorkflowName() {
      const id = this.options.isCopy ? '' : this.formData.procId;

      const isDuplicate = this.workflowGroupList.some(
        (e) => e.procNm === this.formData.procNm && e.procId !== id,
      );
      if (isDuplicate) {
        this.messageValidate = `Workflow group name : ${this.formData.procNm} have been created !`;
        this.$refs.AlertConverterCheckbox.dialog = true;
        this.formData.procNm = '';
        this.$refs.procNm.focus();
        return false;
      }
      return true;
    },
    onDeleteItem(item, nodeId) {
      let self = this;
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        if (nodeId === comp.nodeId) {
          if (comp.comTp === 'COM') {
            self.$refs.communicationRightLayer[0].actionDel();
          } else if (comp.comTp === 'DIR') {
            self.$refs.folderRightLayer[0].onDeleteItem();
          } else if (comp.comTp === 'CVT') {
            self.$refs.converterRightLayer[0].actionDel();
          } else if (comp.comTp === 'FLT') {
            self.$refs.filterRightLayer[0].actionDel();
          }
        }
      });
    },
    checkRightLayerDialog() {
      let check = false;
      let type = '';
      this.dialogs.forEach((val) => {
        this.rightLayerNmList.forEach((e) => {
          if (val.id === e.text + '_0') {
            check = true;
            type = e.text;
          }
        });
      });
      return { check, type };
    },
    drag(ev, data) {
      ev.dataTransfer.setData('node', data);
    },
    drop(ev, type = '', position = null) {
      ev.preventDefault();
      let data = type || ev.dataTransfer.getData('node');
      const editor = this.editor;
      let pos_x, pos_y;
      if (position) {
        pos_x = position.clientX;
        pos_y = position.clientY;
      } else {
        pos_x = ev.clientX;
        pos_y = ev.clientY;
      }

      pos_x =
        pos_x * (editor.precanvas.clientWidth / (editor.precanvas.clientWidth * editor.zoom)) -
        editor.precanvas.getBoundingClientRect().x *
          (editor.precanvas.clientWidth / (editor.precanvas.clientWidth * editor.zoom));
      pos_y =
        pos_y * (editor.precanvas.clientHeight / (editor.precanvas.clientHeight * editor.zoom)) -
        editor.precanvas.getBoundingClientRect().y *
          (editor.precanvas.clientHeight / (editor.precanvas.clientHeight * editor.zoom));

      this.addComponentPK(data, '', {
        posX: pos_x,
        posY: pos_y,
      });
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    copyContent(val) {
      if (this.selectedNode) {
        navigator.clipboard.writeText(val);
        const node = document.getElementById(`node-${this.selectedNode}`);
        node.classList.remove('selected');
        this.editor.node_selected = null;
        this.selectedNode = null;
        this.nodesSelected = [];
        this.editor.drag = false;
        this.$refs.CopyDone.dialog = true;
      }
    },
    openDBMapperVersion(itemRow) {
      let type = 'dbMapperVersionHistory';
      let item = {
        ROWID: 0,
        data: itemRow,
        action: 'dbmapbuilder',
      };
      let indexArrDialog = this.findDialog('dbMapperVersionHistory_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openXmlMapperListDialog() {
      let type = 'xmlMapperList';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('xmlMapperList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifyD2DSQLGroup(rowItem) {
      let type = 'addD2DSqlGroup';
      rowItem.sql_grp_nm = rowItem.sql_grp_name;
      let item = {
        ROWID: 0,
        action: 'modify',
        selectedRow: rowItem,
      };
      let indexArrDialog = this.findDialog('addD2DSqlGroup_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifySQLGroup(rowItem) {
      let type = 'addSqlGroup';
      rowItem.sql_grp_nm = rowItem.sql_grp_name;
      let item = {
        ROWID: 0,
        action: 'modify',
        selectedRow: rowItem,
      };
      let indexArrDialog = this.findDialog('addSqlGroup_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    createDBAChild(data) {
      this.nodesSelected.forEach((eleN) => {
        const node = document.getElementById(`node-${eleN}`);
        node.classList.remove('selected');
      });
      this.nodesSelected = [];

      let id = data.nodeId.split('-').pop();
      let oldData = this.arrProc.filter((e) => e.nodeId != id && e.nodeParent == id);
      if (oldData.length > 0) {
        oldData.forEach((e) => {
          this.editor.removeNodeId(`node-${e.nodeId}`);
          $(`#node-${e.nodeId}-icon`).remove();
          this.arrProc = this.arrProc.filter((item) => item.nodeId !== e.nodeId);
        });
      }

      let info = this.editor.getNodeFromId(parseInt(id));
      let self = this.editor;
      let children = this.dbAdapterListHaveChild.filter(
        (e) => e.dba_id == data.comId && e.dba_child_id !== data.comId,
      );
      children.map((e, i) => {
        const nodeId = this.addComponentPK('DBAC', '', {
          posX: info.pos_x + 250,
          posY: info.pos_y + i * 144,
          comId: e.dba_child_id,
          nodeParent: id,
        });
        self.addConnection(id, nodeId, 'output_1', 'input_1');
        self.removeNodeOutput(nodeId, 'output_1');
      });
    },
    generateApiKey() {
      let d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now();
      }
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    createHiddenBoxes(comParentId, type) {
      let data = this.arrProc.find((e) => e.nodeId == comParentId);
      let boxFormData = {
        resourceId: 'COM-P-G',
        commParentNo: data.comId,
        type: 'API',
        name: '',
        host: cfg.serverIp,
        port: '',
        method: type,
        interval: '1',
        path: '',
        httpHeaders: { 'Content-Type': 'application/json' },
        intervalType: 'MM',
        protocol: 'MESSAGEBOX_API',
        authType: 'bearer',
        authToken: '',
        userid: '',
        password: '',
        security: '',
        email: '',
        fileNmPttn: '',
        comm_mq_nm: '',
        comm_mq_mgr: '',
      };
      let rslt = this.communicationList.find((e) => e.id == data.comId);
      if (type === 'POST') {
        boxFormData.name = rslt.name + 'MSGBX_P';
        boxFormData.path = `msgbox/PROXY/send/${data.comId}/MSG/content`;
      } else {
        boxFormData.name = rslt.name + 'MSGBX_G';
        boxFormData.path = `msgbox/${data.comId}/recv/unread/MSG`;
      }
      this.$store.dispatch('insertCommFromProcSetup', boxFormData);
    },
    loadComponents() {
      // let startTime = performance.now()
      const id = document.getElementById('drawflow');

      this.editor = new Drawflow(id, Vue);
      let self = this;
      /*
        Event of editor
        */
      this.editor.on('nodeCreated', function(id) {
        self.nodeId = id;
      });
      this.editor.on('contextmenu', function(e) {
        if ($('.main-path.selected').length == 0) self.showContextFile(e);
        else self.showMenuFile = false;
      });
      this.editor.on('nodeSelected', function(id) {
        self.selectedNode = id;
        $(`#node-${id}`).removeClass('border-not-selected');
        $(`#node-${self.selectedNode}`).css({ 'z-index': '3' });
        $(`#node-${self.selectedNode}`).addClass('custom-border-drawflow_node');
      });
      this.editor.on('nodeUnselected', function() {
        $(`#node-${self.selectedNode}`).css({ 'z-index': '2' });
        $(`#node-${self.selectedNode}`).removeClass('custom-border-drawflow_node');
        self.selectedNode = '';
      });
      this.editor.start();

      // this.editor.on("zoom", function (level) {
      //   if (level > 1) {
      //     let size = 13 - (level - 1) * 13;
      //     $(".drawflow .v-input .v-input__slot input").css(
      //       "font-size",
      //       size + "px"
      //     );
      //     $(
      //       ".drawflow .v-input__control .v-select__selection.v-select__selection--comma"
      //     ).css("font-size", size + "px");
      //   }
      // });

      /* 203665 rules draw connect between component */
      // 2021.7.6 203728 Change rule components
      this.editor.on('connectionCreated', async function(obj) {
        const ip = getType(obj.input_id);
        const op = getType(obj.output_id);
        const lenOutIn = $(`.node_out_node-${obj.input_id}`).length;
        const lenOutOut = $(`.node_out_node-${obj.output_id}`).length;
        const lenInOut = $(`.node_in_node-${obj.output_id}`).length;

        let arrOut = [];
        let arrOutNode = [];
        for (let i = 0; i < lenOutOut; i++) {
          arrOut.push(
            getType(
              getOutNode($(`.node_out_node-${obj.output_id}`)[i].className.baseVal, obj.output_id),
            ),
          );
          arrOutNode.push(
            'node-' +
              getOutNode(
                $(`.node_out_node-${obj.output_id}`)[i].className.baseVal,
                obj.output_id,
              ).replace(' ', ''),
          );
        }

        self.alertMessage = '';
        self.focusDirIcon = true;

        let checkUCC = false;
        let checkUCRIp = false;
        let checkUCROp = false;
        let checkUCR = false;
        $('.proc-component.v-card.v-sheet').each(function() {
          const comp = $(this)[0].__vue__.$parent;
          const node = comp.$el.parentElement.parentElement.id;
          if (comp.comTp == 'USR') {
            const tp = comp.formData.userType;
            if (node === 'node-' + obj.input_id || node === 'node-' + obj.output_id) {
              if (tp === '') {
                self.alertMessage = self.$t('msg.processSetup.rule8');
                self.focusDirIcon = false;
              } else if (tp === 'UCR' && node === 'node-' + obj.input_id) {
                checkUCRIp = true;
              } else if (tp === 'UCR' && node === 'node-' + obj.output_id) {
                checkUCROp = true;
              }
            }
            if (arrOutNode.includes(node)) {
              if (tp === 'UCC') checkUCC = true;
              if (tp === 'UCR') checkUCR = true;
            }
          }
        });

        // COM can't have in, out at the same time
        if ((op === 'COM' && lenInOut > 0) || (ip === 'COM' && lenOutIn > 0)) {
          self.alertMessage = self.$t('msg.processSetup.comInOut');
          self.focusDirIcon = false;
        }
        if ((checkUCROp && lenInOut > 0) || (checkUCRIp && lenOutIn > 0)) {
          self.alertMessage = self.$t('msg.processSetup.ucrInOut');
          self.focusDirIcon = false;
        }
        // 2022.09.05 213960 SLI-139 Follow Comm HTTP must be API
        if (op === 'COM' && ip === 'COM') {
          if (self.checkRulesComm(obj.output_id, obj.input_id, 2)) {
            self.alertMessage = 'Following Connector have HTTP type must be API type one';
            self.focusDirIcon = false;
          }
        }

        //2022.10.19 TRIG
        // if (ip === "TRIG") {
        //   self.alertMessage = "Trigger can't be located in Destination";
        //   self.focusDirIcon = false;
        // }

        // 2023.7.18 DBA
        if (
          (op === 'DBA' &&
            lenInOut -
              self.arrProc.filter((e) => e.nodeId != obj.output_id && e.nodeParent == obj.output_id)
                .length >
              0) ||
          (ip === 'DBA' &&
            lenOutIn -
              self.arrProc.filter((e) => e.nodeId != obj.input_id && e.nodeParent == obj.input_id)
                .length >
              0)
        ) {
          self.alertMessage = self.$t('msg.processSetup.dsmInOut');
          self.focusDirIcon = false;
        }

        // FLT only behind DIR
        else if (ip === 'FLT' && op !== 'DIR')
          self.alertMessage = self.$t('msg.processSetup.rule1');
        // CVT can't have multi MAP
        else if (op === 'CVT') {
          let checkSRM = false;
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let node = comp.$el.parentElement.parentElement.id;
            if (
              comp.comTp == 'CVT' &&
              node === 'node-' + obj.output_id &&
              comp.formData.cvtrId === '1'
            )
              checkSRM = true;
          });
          if (checkSRM && arrOut.filter((e) => e === 'MAP').length > 1) {
            self.focusDirIcon = false;
            self.alertMessage = self.alertMessage = self.$t('msg.processSetup.rule3');
          }
        } else if (ip === 'CVT' && op === 'MAP') {
          let checkSRM = false;
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let node = comp.$el.parentElement.parentElement.id;
            if (
              comp.comTp == 'CVT' &&
              node === 'node-' + obj.input_id &&
              comp.formData.cvtrId === '1'
            )
              checkSRM = true;
          });
          if (checkSRM) self.alertMessage = self.alertMessage = self.$t('msg.processSetup.rule6');
        }
        // Start with COM or DIR
        // 2022.9.5 203728 check rule for UCC
        else if (op === 'COM' || op === 'DIR' || op === 'DBA' || checkUCROp) {
          if (arrOut.length > 1) {
            if (arrOut.filter((e) => e === 'CVT').length > 0)
              self.alertMessage = self.$t('msg.processSetup.rule4');
            if (checkUCC) self.alertMessage = self.$t('msg.processSetup.rule9');
          }
          if (op !== 'DIR') {
            if (
              (arrOut.filter((e) => e === 'COM').length > 0 ||
                arrOut.filter((e) => e === 'DBA').length > 0 ||
                checkUCR) &&
              arrOut.filter((e) => e === 'MAP').length > 0
            )
              self.alertMessage = self.$t('msg.processSetup.rule5');
          }
        }
        // SPKA-539 mapper-mapper must be allowed.
        if (!self.alertMessage && (op === 'MAP' || ip === 'MAP')) {
          let out = op === 'MAP';
          let id = parseInt(op === 'MAP' ? obj.output_id : obj.input_id);
          let routes = [];
          let waitList = [];
          const data = self.getData4Router();
          let e = Object.values(data).filter((key) => key.id == id)[0];

          await self.getRoad4Map(data, e, routes, [], waitList, out);
          await self.repeatBack(waitList, data, routes, out);

          routes.map((e) => {
            if (
              e[0].class == 'MAP' &&
              e[e.length - 1].class == 'MAP' &&
              e.some((r) => r.class == 'CVT' || (r.class == 'USR' && r.data.userType == 'UCC')) &&
              !e.some((r) => r.class == 'DIR')
            ) {
              self.alertMessage = self.$t('msg.processSetup.rule10');
            }
          });
        }

        if (self.alertMessage) {
          self.editor.removeSingleConnection(
            obj.output_id,
            obj.input_id,
            obj.output_class,
            obj.input_class,
          );
          return (self.$refs.AlertAddDirComponent.dialog = true);
        } else {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let node = comp.$el.parentElement.parentElement.id;
            if (comp.comTp == 'USR') {
              if (node === 'node-' + obj.input_id || node === 'node-' + obj.output_id) {
                comp.userDisable = true;
                comp.openRightLayer();
              }
            }
          });
        }
      });
      // let endTime = performance.now()
      // this.timeLoadComps = endTime - startTime;

      this.editor.on('connectionRemoved', function(obj) {
        const lenOutIn = $(`.node_out_node-${obj.input_id}`).length;
        const lenOutOut = $(`.node_out_node-${obj.output_id}`).length;
        const lenInOut = $(`.node_in_node-${obj.output_id}`).length;
        const lenInIn = $(`.node_in_node-${obj.input_id}`).length;

        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          let node = comp.$el.parentElement.parentElement.id;
          if (comp.comTp == 'USR') {
            if (
              (node === 'node-' + obj.output_id && lenOutOut + lenInOut === 0) ||
              (node === 'node-' + obj.input_id && lenOutIn + lenInIn === 0)
            ) {
              comp.userDisable = false;
              comp.openRightLayer();
            }
          }
        });
      });

      self.editor.on('connectionSelected', (obj) => {
        // output_id, input_id, output_class, input_class
        let info = self.arrProc.filter((e) => e.nodeId == obj.input_id);
        if (info && info[0].comTp == 'DBAC') {
          self.editor.connection_selected = null;
        }
      });

      self.editor.on('clickEnd', (e) => {
        self.nodesSelected.forEach((eleN) => {
          const node = document.getElementById(`node-${eleN}`);
          if (node) node.classList.remove('selected');
        });
        self.nodesSelected = [];

        if (self.editor.node_selected !== null) {
          const nodeId = self.editor.node_selected.id.slice(5);
          let data = self.arrProc.filter((e) => e.nodeParent == nodeId);
          if (data.length > 0) {
            data.forEach((e) => {
              const node = document.getElementById(`node-${e.nodeId}`);
              node.classList.add('selected');
              self.nodesSelected.push(e.nodeId);
            });
          }
        }
      });

      self.editor.on('click', (e) => {
        if (
          e.target.className === 'proc-comp-name' ||
          e.target.parentElement.className === 'proc-comp-name'
        ) {
          const id = e.target.id;
          const nodeId = id.substring(0, id.length - 5);
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;

            if (comp.nodeId === nodeId) {
              comp.openRightLayer();
              return;
            }
          });
        }
        if (e.target.id === 'drawflow' || e.target.parentElement.id === 'drawflow') {
          if (self.checkRightLayerDialog().check) {
            const type = self.checkRightLayerDialog().type;
            if (self.$refs[type][0]) {
              setTimeout(() => {
                self.$refs[type][0].closeComDialog();
              }, 300);
            }
          }
        }
      });

      let last_x = 0;
      let last_y = 0;
      self.editor.on('mouseMove', ({ x, y }) => {
        if (self.editor.node_selected && self.editor.drag) {
          $('.cus-bg-dialog').addClass('hidden');
          $(`#${self.editor.node_selected.id}`).addClass('cursor-move');
          self.nodesSelected.forEach((eleN) => {
            if (eleN != self.editor.node_selected.id.slice(5)) {
              const node = document.getElementById(`node-${eleN}`);
              let xnew =
                ((last_x - x) * self.editor.precanvas.clientWidth) /
                (self.editor.precanvas.clientWidth * self.editor.zoom);
              let ynew =
                ((last_y - y) * self.editor.precanvas.clientHeight) /
                (self.editor.precanvas.clientHeight * self.editor.zoom);

              node.style.top = node.offsetTop - ynew + 'px';
              node.style.left = node.offsetLeft - xnew + 'px';

              // 2022.12.05 213960 change position of component name follow component position
              let div = document.getElementById(`node-${eleN}-icon`);
              if (div && div.style) {
                div.style.top =
                  parseInt(node.style.top.substring(0, node.style.top.length - 2)) + 53 + 'px';
                div.style.left =
                  parseInt(node.style.left.substring(0, node.style.left.length - 2)) - 100 + 'px';
              }

              self.editor.drawflow.drawflow[self.editor.module].data[eleN].pos_x =
                node.offsetLeft - xnew;
              self.editor.drawflow.drawflow[self.editor.module].data[eleN].pos_y =
                node.offsetTop - ynew;
              self.editor.updateConnectionNodes(`node-${eleN}`);
            }
          });
        }
        if (self.editor.node_selected && !self.editor.drag) {
          $(`#${self.editor.node_selected.id}`).removeClass('cursor-move');
          $('.cus-bg-dialog').removeClass('hidden');
        }
        const nodes = document.querySelectorAll(`.drawflow-node`);
        nodes.forEach((node) => {
          node.addEventListener('mouseover', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              if (id == node.id) {
                comp.showClose = true;
              }
            });
          });
          node.addEventListener('mouseleave', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              comp.showClose = false;
            });
          });
        });
        // 2022.12.05 213960 change position of component name follow component position
        if (self.selectedNode) {
          const id = self.selectedNode;
          let element = document.getElementById(`node-${id}`),
            style = window.getComputedStyle(element),
            top = style.getPropertyValue('top'),
            left = style.getPropertyValue('left');
          let div = document.getElementById(`node-${id}-icon`);
          if (div && div.style) {
            div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
            div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
          }
        }

        last_x = x;
        last_y = y;
      });
    },
    closeWFAndMoveMapBuilder(json) {
      this.sendMessage('move-mapbuilder' + json);
    },
    viewFileMoveDBMapBuilder(item) {
      this.sendMessage('move-dbmapbuilder' + JSON.stringify(item));
    },
    // 2021.9.29 203728 SPKA-222 open mapper version
    openMapperVersion(val) {
      let type = 'mapperVersion';
      let item = {
        ROWID: 0,
        data: val,
      };
      this.flatFileVersionHistoryItem = val;
      let indexArrDialog = this.findDialog('mapperVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    // 2021.9.29 203728 SPKA-222 refresh version
    async refreshMapComp() {
      let masterSearchItems = {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: this.$cookies.get('user-admin-yn'),
            CUST_ID: this.$cookies.get('comp-id'),
          },
        ],
      };
      await Store.dispatch('map/queryMapListByProcSetup', masterSearchItems);
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        let tp = comp.comTp;
        if (tp == 'MAP') {
          comp.selectMap('', true);
        }
      });
    },
    // 2022.09.05 213960 SLI-139 Check rule Comm
    checkRulesComm(outputId, inputId, count) {
      let indexCom1 = this.arrProc.findIndex((e) => e.nodeId == outputId);
      let indexCom2 = this.arrProc.findIndex((e) => e.nodeId == inputId);
      let commOutput, commInput;

      for (let i = 0; i < this.communicationList.length; i++) {
        if (this.arrProc[indexCom1].comId == this.communicationList[i].id) {
          commOutput = this.communicationList[i];
        }
        if (this.arrProc[indexCom2].comId == this.communicationList[i].id) {
          commInput = this.communicationList[i];
        }
      }
      if (count > 2) {
        if (commOutput.type == 'HTTP') return false;
        else return true;
      }
      if (commOutput.type == 'HTTP' && commInput.type !== 'API' && count == 2) return true;
      return false;
    },
    // 2021.10.19 203728 SPKA-224 refresh component list data after insert / update
    // 2021.10.26 203728 SPKA-224 return data not get store
    refreshComponent(val) {
      let self = this;
      if (val.type === 'COM') {
        this.$store.dispatch('getCommunicationSelectBoxList').then(() => {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == val.type) {
              comp.selectComm();
              if (val.nodeId == comp.nodeId) {
                comp.formData.id = val.comId;
                comp.selectComm();
                let indexArrDialog = self.findDialog('communicationRightLayer_0');
                if (indexArrDialog != null) {
                  self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                  self.$refs.communicationRightLayer[0].initialize();
                }
              }
            }
          });
        });
      } else if (val.type === 'FLT') {
        this.$store.dispatch('getFilterSelectBoxList').then(() => {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == val.type) {
              comp.selectFilter();
              if (val.nodeId == comp.nodeId) {
                comp.formData.fltrId = val.comId;
                comp.selectFilter();
                let indexArrDialog = self.findDialog('filterRightLayer_0');
                if (indexArrDialog != null) {
                  self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                  self.$refs.filterRightLayer[0].initialize();
                }
              }
            }
          });
        });
      } else if (val.type === 'CVT') {
        this.$store.dispatch('getCvtrGrpList').then(() => {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == val.type) {
              comp.selectConverter();
              if (val.nodeId == comp.nodeId) {
                comp.formData.cvtrId = val.comId;
                comp.selectConverter();
                let indexArrDialog = self.findDialog('converterRightLayer_0');
                if (indexArrDialog != null) {
                  self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                  self.$refs.converterRightLayer[0].initialize();
                }
              }
            }
          });
        });
      }
      // else if (val.type === "TRIG") {
      //   this.$store.dispatch("getTriggerSelectBoxList").then((res) => {
      //     let data = res;
      //     this.triggerList = data;
      //     $(".proc-component.v-card.v-sheet").each(function () {
      //       let comp = $(this)[0].__vue__.$parent;
      //       if (comp.comTp == val.type) {
      //         comp.triggerIdSelectList = data;
      //         comp.selectTriggerDetail();
      //         if (val.nodeId == comp.nodeId) {
      //           comp.formData.tr_id = val.comId;
      //           comp.selectTriggerDetail();
      //           let indexArrDialog = self.findDialog("triggerRightLayer_0");
      //           if (indexArrDialog != null) {
      //             self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
      //             self.$refs.triggerRightLayer[0].initialize();
      //           }
      //         }
      //       }
      //     });
      //   });
      // } else if (val.type === "DIR") {
      //   this.leftItems.data[0].USER_ID = this.$cookies.get("user-id");
      //   this.$store.dispatch("queryFolderList", this.leftItems).then(() => {
      //     let data = this.$store.getters.foldList;
      //     this.foldList = data;
      //     $(".proc-component.v-card.v-sheet").each(function () {
      //       let comp = $(this)[0].__vue__.$parent;
      //       if (comp.comTp == val.type) {
      //         comp.folderList = self.foldList;
      //         comp.selectFolder();
      //       }
      //     });
      //   });
      // }
    },
    async reloadComponent() {
      if (this.options.dataValue !== undefined) {
        const params = {
          procId: this.options.dataValue,
          hash: this.$cookies.get('hash'),
        };
        this.$store.dispatch('getWorkflowGroupDtlList', params).then(() => {
          this.loadArrProc = this.$store.getters.workflowGroupDtlList;
          this.$nextTick(() => this.updateComponent());
        });
      }
    },
    // 2021.10.26 203728 SPKA-224 change param
    openDelHistoryWorkflowDialog(list, val, nodeId) {
      // console.log(val);
      let type = 'DelHistoryWorkflowDialog';
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.item = val;
      item.nodeId = nodeId;
      let indexArrDialog = this.findDialog('DelHistoryWorkflowDialog_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddIdentification(num) {
      this.idenType = num;
      let type = 'addIdentification';
      let item = {
        ROWID: 0,
        isEdit: false,
        data: this.formData,
      };
      let indexArrDialog = this.findDialog('addIdentification_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddPartnerDialog() {
      this.idenType = 0;
      let type = 'addPartnerLayout';
      let item = {
        ROWID: 0,
        action: 'add',
      };
      let indexArrDialog = this.findDialog('addPartnerLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openUserComponentVersion(itemRow) {
      let type = 'userVersionHistory';
      let item = {
        ROWID: 0,
        data: itemRow,
      };
      let indexArrDialog = this.findDialog('userVersionHistory_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    async openRightLayer(data) {
      const type = this.rightLayerNmList.filter((e) => e.value === data.comTp)[0].text;
      let item = {
        ROWID: 0,
        data: data,
      };
      if (this.checkRightLayerDialog().check) {
        await EventBus.$emit('check-right-layer-change');
        if (this.checkRightLayerDialog().check) {
          return;
        }
        this.newDialog(item, type) - 1;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = {
        left: 30 * this.dialogId,
        top: 30 * this.dialogId + 20,
        item,
      };
      let companyId = '';
      switch (this.idenType) {
        case 0:
          companyId = this.formData.compId;
          break;
        case 1:
          companyId = 'C,' + this.formData.senderId;
          break;
        case 2:
          companyId = 'P,' + this.formData.receiverId;
          break;
      }
      return { id, name, type, options, companyId };
    },
    removeDialogPopup(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    updateConnections(id) {
      this.editor.updateConnectionNodes(id.nodeId);
    },
    clickHandler(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].comId = data.comId;
          $(`#node-${this.arrProc[i].nodeId}`).removeClass('border-invalid');
          $(`#node-${this.arrProc[i].nodeId}`).addClass('custom-border');
        }
      }
      // 2022.12.05 213960 add/change component name
      const compTpNm = this.compTpNmList.filter((e) => e.value === data.comTp)[0].text;
      if (!document.getElementById(`${data.nodeId}-icon`)) {
        if (!data.nodeId) {
          return;
        }
        let element = document.getElementById(data.nodeId),
          style = window.getComputedStyle(element),
          top = style.getPropertyValue('top'),
          left = style.getPropertyValue('left');
        let div = document.createElement('div');
        div.id = `${data.nodeId}-icon`;
        div.className = 'proc-comp-name';
        div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
        div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
        div.style.cursor = 'pointer';
        let p = document.createElement('p');
        p.id = `${data.nodeId}-name`;
        if (!data.comId) {
          let name = document.createTextNode('Select ' + compTpNm + ' ..');
          p.appendChild(name);
          p.style.color = '#9AAAC3';
        } else {
          let name = document.createTextNode(data.comName);
          p.appendChild(name);
        }
        div.appendChild(p);
        element.after(div);
      } else {
        if (!data.comId) {
          $(`#${data.nodeId}-icon`).text('Select ' + compTpNm + ' ..');
          $(`#${data.nodeId}-icon`).css({ color: '#9AAAC3' });
        } else {
          $(`#${data.nodeId}-icon`).text(data.comName);
          $(`#${data.nodeId}-icon`).css({
            color: this.$vuetify.theme.dark ? '#FFFFFF' : '#000000',
          });
        }
      }
    },
    setDirPath(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].path = data.dirPath;
          // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
          this.arrProc[i].comId = data.foldId;
          // console.log("DIR: ", this.arrProc[i]);
          return;
        }
      }
    },
    emitComInfo(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].comInfo = data.info;
          return;
        }
      }
    },
    delNodeComponent(nodeId, mapperId) {
      let self = this;
      // remove right layer when remove component
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        if (comp.nodeId == nodeId) {
          const type = self.rightLayerNmList.filter((e) => e.value === comp.comTp)[0].text;
          let indexArrDialog = self.findDialog(type + '_0');
          if (indexArrDialog != null) {
            self.$refs[type][0].removeDialog();
          }
        }
      });
      if (nodeId != '') {
        let id = parseInt(nodeId.split('-').pop());
        let data = this.arrProc.filter((e) => e.nodeParent == id && e.nodeId !== id);
        // console.log(this.arrProc);
        if (data.length > 0) {
          data.forEach((e) => {
            this.editor.removeNodeId(`node-${e.nodeId}`);
            $(`#node-${e.nodeId}-icon`).remove();
            this.arrProc = this.arrProc.filter((item) => item.nodeId !== e.nodeId);
          });
          this.nodesSelected = [];
        }

        this.editor.removeNodeId(nodeId);
        // 2022.12.05 213960 remove component name
        $(`#${nodeId}-icon`).remove();
        this.selectedNode = '';
        this.arrProc = this.arrProc.filter((item) => item.nodeId !== id);
      }

      //203737 04/20/2021 Remove mapper after close mapper
      let arrProc = this.arrProc;
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        let tp = comp.comTp;
        if (tp == 'MAP') {
          comp.listComIdChange = arrProc;
        }
      });
      this.mappers = this.mappers.filter((item) => item.mapperId !== mapperId);
    },
    showContextFile(e) {
      e.preventDefault();
      this.showMenuFile = true;
      this.x = e.clientX;
      this.y = e.clientY;
      if (this.selectedNode !== '') {
        this.contextsFile = [
          { text: 'Add input', icon: 'edit' },
          { text: 'Add output', icon: 'edit' },
          { text: 'Remove input', icon: 'edit' },
          { text: 'Remove output', icon: 'edit' },
        ];
      } else {
        this.contextsFile = [
          { text: 'Connector', icon: 'proc-comm', type: 'COM' },
          // { text: "Filter", icon: "proc-filter", type: "FLT" },
          // { text: "Folder", icon: "proc-folder", type: "DIR" },
          { text: 'Mapper', icon: 'proc-mapper', type: 'MAP' },
          { text: 'Converter', icon: 'proc-converter', type: 'CVT' },
          { text: 'User Component', icon: 'proc-usr', type: 'USR' },
          // { text: "Trigger Component", icon: "proc-trigger", type: "TRIG" },
          { text: 'DB Adapter', icon: 'proc-dsm', type: 'DBA' },
        ].filter((e) => this.authCompList[e.type]?.manage);
      }
    },
    /* 203665 Add new component funtion */
    addComponentPK(componentType, componentId, datachild) {
      const props = {
        comId: '',
        nodeId: '100',
        listSender: this.listSender,
        listRecipient: this.listRecipient,
        listComId: this.arrProc,
      };
      props.comId = componentId !== undefined ? componentId : '';

      const options = {
        store: store,
        i18n: i18n,
        vuetify: vuetify,
      };

      const procData = {
        comNm: '',
        comTp: '',
        comId: '',
        comInfo: '',
        path: '',
        nodeId: '',
        nodeInfo: '',
      };
      // 2021.10.19 203728 SPKA-224 set data list
      switch (componentType) {
        case 'COM':
          props.protocolList = this.protocolList;
          props.manage = this.authCompList.COM.manage;
          this.editor.registerNode(componentType, procComm, props, options);
          procData.comNm = 'procComm';
          procData.comTp = 'COM';
          break;
        case 'MAP':
          props.manage = this.authCompList.MAP.manage;
          this.editor.registerNode(componentType, procMapper, props, options);
          procData.comNm = 'procMapper';
          procData.comTp = 'MAP';
          break;
        case 'FLT':
          props.fltrTpCdList = this.fltrTpCdList;
          props.manage = this.authCompList.FLT.manage;
          this.editor.registerNode(componentType, procFilter, props, options);
          procData.comNm = 'procFilter';
          procData.comTp = 'FLT';
          break;
        case 'CVT':
          props.cvtrTpCdList = this.cvtrTpCdList;
          props.manage = this.authCompList.CVT.manage;
          props.manageDBB = this.authCompList.DBB.manage;
          this.editor.registerNode(componentType, procConverter, props, options);
          procData.comNm = 'procConverter';
          procData.comTp = 'CVT';
          break;
        case 'DIR':
          this.editor.registerNode(componentType, procDir, props, options);
          procData.comNm = 'procDir';
          procData.comTp = 'DIR';
          break;
        case 'USR':
          props.comTp = 'USR';
          props.manage = this.authCompList.USR.manage;
          this.editor.registerNode(componentType, procUser, props, options);
          procData.comNm = 'procUser';
          procData.comTp = 'USR';
          break;
        // case "TRIG":
        //   props.triggerList = this.triggerList;
        //   props.comTp = "TRIG";
        //   this.editor.registerNode(componentType, procTrig, props, options);
        //   procData.comNm = "procTrig";
        //   procData.comTp = "TRIG";
        //   break;
        case 'DBA':
          props.isDisable = true;
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          procData.nodeParent = this.nodeId;
          procData.comNm = 'procDBAdapter';
          procData.comTp = 'DBA';
          break;
        case 'DBAC':
          props.isDisable = true;
          props.comId = datachild.comId;
          props.comTp = 'DBAC';
          props.manage = this.authCompList.DBA.manage;

          this.editor.registerNode(componentType, procDBAdapter, props, options);
          procData.comNm = 'procDBAdapterChild';
          procData.comTp = 'DBAC';
          procData.nodeParent = datachild.nodeParent;
          break;
      }

      procData.comId = componentId !== undefined ? componentId : '';

      const data = { comId: '', nodeId: '' };

      let len = this.arrProc.length;
      let height = document.getElementById('drawflow').clientHeight;
      let width = document.getElementById('drawflow').clientWidth;
      this.editor.addNode(
        'Name',
        1,
        1,
        datachild ? datachild.posX : Math.floor(width / 2) - 25,
        datachild ? datachild.posY : Math.floor(height / 2) - 25,
        `${componentType}`,
        data,
        componentType,
        'vue',
      );
      procData.nodeId = this.nodeId;

      this.arrProc.push(procData);
      this.arrProc.forEach((e) => {
        if (e.nodeId == this.nodeId) {
          $(`#node-${e.nodeId}`).addClass('border-not-selected');
        } else {
          $(`#node-${e.nodeId}`).removeClass('border-not-selected');
        }
      });
      this.nodeId = '';
      if (componentType == 'DBAC') {
        return procData.nodeId;
      }
    },
    async fileMenuAction(ev, item) {
      if (item.text == 'Add input') {
        let info = this.editor.getNodeFromId(this.selectedNode);
        if (info.inputs.input_1 === undefined) {
          this.editor.addNodeInput(this.selectedNode);
        } else {
          return;
        }
      } else if (item.text == 'Add output') {
        let info = this.editor.getNodeFromId(this.selectedNode);
        if (info.outputs.output_1 === undefined) {
          this.editor.addNodeOutput(this.selectedNode);
        } else {
          return;
        }
      } else if (item.text == 'Remove input') {
        let info = this.editor.getNodeFromId(this.selectedNode);
        this.editor.removeNodeInput(this.selectedNode, 'input_1');
      } else if (item.text == 'Remove output') {
        let info = this.editor.getNodeFromId(this.selectedNode);
        this.editor.removeNodeOutput(this.selectedNode, 'output_1');
      } else if (item.icon) {
        this.drop(ev, item.type, { clientX: this.x, clientY: this.y });
      }
    },

    getNodeData(id) {
      let dataRes = this.editor.getNodeFromId(id);
      this.nodeId = '';
      return dataRes;
    },

    async getRoad(data, obj, routes, arr, waitList) {
      arr.unshift(obj);

      let inputList = obj.inputs.input_1;
      let len = inputList ? inputList.connections.length : 0;
      let pt = '';

      if (len > 0) {
        pt = inputList.connections[0].node;

        if (len > 1) {
          let obj = inputList.connections.filter((e) => e.node != pt);
          obj.forEach((r) => {
            // 2021.6.2 203728 Add index for waitList
            this.indexRoute++;
            waitList.push({
              point: r.node,
              arr: [].concat(arr),
              index: this.indexRoute,
            });
          });
        }

        return await this.getRoad(
          data,
          Object.values(data).filter((e) => e.id == pt)[0],
          routes,
          arr,
          waitList,
        );
      }

      // let v = {arr: arr, list: waitList, pt: pt}
      routes.push(arr);
      return routes;
    },
    async getRoad4Map(data, obj, routes, arr, waitList, out) {
      arr.unshift(obj);
      if (arr.filter((e) => e.class == 'MAP').length < 2) {
        let list = out ? obj.outputs.output_1 : obj.inputs.input_1;
        let len = list ? list.connections.length : 0;
        let pt = '';

        if (len > 0) {
          pt = list.connections[0].node;

          if (len > 1) {
            let obj = list.connections.filter((e) => e.node != pt);
            obj.forEach((r) => {
              this.indexRoute++;
              waitList.push({
                point: r.node,
                arr: [].concat(arr),
                index: this.indexRoute,
              });
            });
          }

          return await this.getRoad4Map(
            data,
            Object.values(data).filter((e) => e.id == pt)[0],
            routes,
            arr,
            waitList,
            out,
          );
        }
      }

      routes.push(arr);
      return routes;
    },
    async repeatBack(waitList, data, routes, out) {
      await Promise.all(
        waitList.map(async (e) => {
          let pt = Object.values(data).filter((r) => r.id == e.point)[0];
          await this.getRoad4Map(data, pt, routes, e.arr, waitList, out);
          waitList = waitList.filter((r) => r.index != e.index);
        }),
      );
      if (waitList.length > 0) this.repeatBack(waitList, data, routes, out);
    },
    async repeat(waitList, data, routes) {
      await Promise.all(
        waitList.map(async (e) => {
          // SPKA-49 2021.3.15 [Fix issue case 6 - special]: Change method get router path from "position" to "id of node" of component
          let pt = Object.values(data).filter((r) => r.id == e.point)[0];
          await this.getRoad(data, pt, routes, e.arr, waitList);
          // 2021.6.2 203728 Remove from waitList by index
          waitList = waitList.filter((r) => r.index != e.index);
        }),
      );
      if (waitList.length > 0) this.repeat(waitList, data, routes);
    },
    getData4Router() {
      // get & set user type
      const self = this;
      $('.proc-component.v-card.v-sheet').each(function() {
        const comp = $(this)[0].__vue__.$parent;
        const node = comp.$el.parentElement.parentElement.id;
        if (comp.comTp == 'USR') {
          const tp = comp.formData.userType;
          const index = self.arrProc.findIndex((e) => 'node-' + e.nodeId == node);
          self.arrProc[index].userType = tp;
        }
      });

      let arrNodeInfo = [];
      this.arrProc.forEach((item) => {
        let info = this.getNodeData(item.nodeId);
        info.data.comId = item.comId;
        if (item.comTp == 'DIR' && item.comId === '') {
          this.addDirInfo(item, info);
          info.data.comId = item.comId;
        }
        if (item.comTp == 'DBA') {
          info.data.countChild = this.arrProc.filter(
            (e) => e.nodeId != item.nodeId && e.nodeParent == item.nodeId,
          ).length;
        }
        if (item.comTp == 'DBAC') {
          info.data.nodeParent = item.nodeParent;
        }
        if (item.comTp == 'USR') {
          info.data.userType = item.userType;
        }
        arrNodeInfo.push(info);
        item.nodeInfo = JSON.stringify(info);
      });
      let i = 1;
      const arrayToObject = (arr) => Object.assign({}, ...arr.map((item) => ({ [i++]: item })));

      return arrayToObject(arrNodeInfo);
    },
    /* 203665 Function get all line connection on screen */
    async getRoutes(isSave) {
      const data = this.getData4Router();
      // let tries = this.editor.export().drawflow.Home.data;

      let leaves = Object.values(data).filter(
        (key) => !key.outputs.output_1 || key.outputs.output_1.connections.length == 0,
      );

      let routes = [];
      // 2021.6.2 203728 Reset index route
      this.indexRoute = 0;
      let waitList = [];
      await Promise.all(
        leaves.map(async (e) => {
          await this.getRoad(data, e, routes, [], waitList);
        }),
      );

      await this.repeat(waitList, data, routes);

      routes.forEach((e) => {
        e.forEach((r) => {
          $(`.node_in_node-${r.id} .main-path`).css({ stroke: '#1266ab' });
          $(`#node-${r.id}`).removeClass('border-invalid');
          $(`#node-${r.id}`).addClass('custom-border');
        });
      });

      let check = false;
      // 05/25/2021 203737 SPKA-121 issue 67 Modify the connection between COM - COM
      // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
      /**
       * 2021.07.06 203737 SPKA-150 issue 98 Fix the no. 5. Start with DIR in "CLT_TestCase" sheet
       * Validation source and destination: COM or DIR
       */
      if (isSave) {
        let checkUCC = function(id) {
          let check = false;
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            let node = comp.$el.parentElement.parentElement.id;

            if (comp.comTp == 'USR' && node === 'node-' + id && comp.formData.userType === 'UCC') {
              check = true;
            }
          });
          return check;
        };

        routes.forEach((e) => {
          let len = e.length;
          if (len < 2) {
            e.forEach((r) => {
              $(`#node-${r.id}`).addClass('border-invalid');
            });
            check = true;
          } else if (
            e[0].class != 'MAP' &&
            e[0].class != 'DIR' &&
            e[0].class != 'CVT' &&
            !checkUCC(e[0].id)
          ) {
            e.forEach((r) => {
              $(`.node_in_node-${r.id} .main-path`).css({ stroke: 'red' });
              this.$refs.checkSRCDST.dialog = true;
              this.messageValidate = this.$t('msg.workflowGroup.warningSRC');
            });
            check = true;
          } else if (
            e[len - 1].class != 'COM' &&
            e[len - 1].class != 'MAP' &&
            e[len - 1].class != 'DIR' &&
            e[len - 1].class != 'CVT' &&
            !checkUCC(e[len - 1].id)
          ) {
            e.forEach((r) => {
              $(`.node_in_node-${r.id} .main-path`).css({ stroke: 'red' });
              this.$refs.checkSRCDST.dialog = true;
              this.messageValidate = this.$t('msg.workflowGroup.warningDST');
            });
            check = true;
          }
        });
      }
      if (check) return [];
      else return routes;
    },
    /* 203665 Save process setup funtion */
    async save(applyStatus) {
      let self = this;
      // console.log("Apply Status", applyStatus);
      // Calculation all routes
      let routes = await this.getRoutes(true);
      if (routes.length === 0) {
        return;
      }

      /* [S] 203665 validate form data */
      this.formHasErrors = false;
      this.procComsColor = '';
      // 2022.10.19 213960 check multiple SRC and multiple DST
      if (routes.length > 1) {
        let SRCList = [];
        let DSTList = [];
        SRCList.push(routes[0][0]);
        DSTList.push(routes[0][routes[0].length - 1]);
        let isMultipleSRC = false;
        let isMultipleDST = false;
        routes.forEach((e) => {
          let len = e.length;
          let indexSRC = SRCList.findIndex((item) => item.id === e[0].id);
          let indexDST = DSTList.findIndex((item) => item.id === e[len - 1].id);
          if (indexSRC == -1) isMultipleSRC = true;
          if (
            indexDST == -1 &&
            (e[len - 1].class !== 'COM' || routes[0][routes[0].length - 1].class !== 'COM')
          )
            isMultipleDST = true;
          SRCList.push(e[0]);
          DSTList.push(e[len - 1]);
        });
        // 2022.10.19 213960 multiple SRC is not allowed
        if (isMultipleSRC) {
          self.formHasErrors = true;
          self.$refs.checkSRCDST.dialog = true;
          self.messageValidate = self.$t('msg.workflowGroup.warningMultipleSRC');
        }
        // 2022.10.19 213960 if Communication is used as DST, multiple DST is allowed
        if (isMultipleDST) {
          self.formHasErrors = true;
          self.$refs.checkSRCDST.dialog = true;
          self.messageValidate = self.$t('msg.workflowGroup.warningMultipleDST');
        }
      }

      Object.keys(this.formData).forEach((key) => {
        if (this.$refs[key] !== undefined) {
          if (!this.formData[key] || this.formData[key] === '') {
            this.$refs[key].focus();
            this.formHasErrors = true;
          }
          this.$refs[key].validate(true);
        }
      });

      if (!this.validateWorkflowName()) {
        this.formHasErrors = true;
        this.$refs.procNm.focus();
      }

      // if (
      //   this.formData.receiverId === this.formData.senderId &&
      //   this.formData.senderId !== "*" &&
      //   this.formData.receiverId !== "*"
      // ) {
      //   this.formHasErrors = true;
      // }
      if (this.arrProc.length === 0) {
        this.formHasErrors = true;
      }
      // 203665 Update check procComId null
      for (let i = 0; i < this.arrProc.length; i++) {
        const procCom = this.arrProc[i];
        if (procCom.comId === '' || (procCom.comTp == 'DIR' && procCom.path == '')) {
          $(`#node-${procCom.nodeId}`).addClass('border-invalid');
          this.formHasErrors = true;
        }
      }
      //203737 04/12/2021 Validate SRM List Empty in Mapper
      //2021.5.18 203728 Add condition isUseDifferentEDI
      // 2021.7.7 203728 Check add sender recipient like default
      // 2021.7.9 203728 Catch if sender, recipient empty when check isUseDifferentEDI
      // let arrMapIdEmpty = [];
      let list4ChkDup = [];
      let checkSR = false;
      self.focusDirIcon = true;

      // $(".proc-component.v-card.v-sheet").each(function () {
      //   let comp = $(this)[0].__vue__.$parent;
      //   if (comp.comTp == "MAP") {
      //     if (
      //       comp.listSrm.length === 1 &&
      //       comp.listSrm[0].sender.id === self.getSenderIdDefault().id &&
      //       comp.listSrm[0].recipient.id === self.getReceiverIdDefault().id
      //     ) {
      //       self.focusDirIcon = false;
      //       self.alertMessage = self.$t("msg.processSetup.ruleEDICheckbox");
      //       $(`#${comp.$el.parentElement.parentElement.id}`).addClass(
      //         "border-invalid"
      //       );
      //       self.formHasErrors = true;
      //       self.$refs.AlertAddDirComponent.dialog = true;
      //       return false;
      //     }

      //     list4ChkDup.push({
      //       name:
      //         comp.mapInfo.mapMsgId +
      //         comp.mapInfo.mapInfo +
      //         JSON.stringify(comp.listSrm),
      //       comp: comp,
      //     });
      //     comp.listSrm.map((element) => {
      //       if (
      //         (element.sender === "" ||
      //           element.sender.srId === "" ||
      //           element.recipient === "" ||
      //           element.recipient.srId === "") &&
      //         element.isUseDifferentEDI == 1
      //       ) {
      //         // arrMapIdEmpty.push(comp.mapperId);
      //         $(`#${comp.$el.parentElement.parentElement.id}`).addClass(
      //           "border-invalid"
      //         );
      //         checkSR = true;
      //         return;
      //       }
      //     });
      //   }
      // });

      if (checkSR) {
        self.focusDirIcon = false;
        self.alertMessage = self.$t('msg.processSetup.emptySR');
        self.formHasErrors = true;
        return (self.$refs.AlertAddDirComponent.dialog = true);
      }

      // 2021.7.7 203728 Check duplicate by SRM - version has diffirent id.
      let arrChk = list4ChkDup.map((e) => {
        return e.name;
      });
      let isDuplicate = arrChk.findIndex((e, i) => {
        return arrChk.indexOf(e) != i;
      });

      if (isDuplicate > -1) {
        self.focusDirIcon = false;
        self.alertMessage = self.$t('msg.processSetup.dupInfoMap');
        $(`#${list4ChkDup[isDuplicate].comp.$el.parentElement.parentElement.id}`).addClass(
          'border-invalid',
        );
        self.formHasErrors = true;
        return (self.$refs.AlertAddDirComponent.dialog = true);
      }

      if (this.formHasErrors) return;
      this.formData.routes = routes;
      this.saveHiddenBoxes(routes);
      this.formData.applyStatus = applyStatus;
      if (applyStatus === 'A') {
        this.openProcessApplyHistory({ procNm: this.formData.procNm });
      } else {
        if (!this.formHasErrors) {
          this.saveDataToServer();
          EventBus.$on('set-map-contract', this.setInfoContract);
        }
      }
    },
    saveHiddenBoxes(routes) {
      routes.forEach((e) => {
        let len = e.length;
        if (
          len > 2 &&
          e[0].class === 'COM' &&
          e[len - 1].class === 'COM' &&
          !this.checkRulesComm(e[0].id, e[len - 1].id, len)
        ) {
          this.createHiddenBoxes(e[0].id, 'POST');
          this.createHiddenBoxes(e[0].id, 'GET');
        }
      });
    },

    async saveDataToServer() {
      // Set receiverEdiNm before save
      // let index = this.getPrnrList.findIndex(
      //   (e) => e.value === this.formData.receiverId
      // );
      // this.formData.receiverEdiNm =
      //   index > -1 ? this.getPrnrList[index].text : "";

      // Set senderEdiNm before save
      // index = this.getPrnrList.findIndex(
      //   (e) => e.value === this.formData.senderId
      // );
      // this.formData.senderEdiNm =
      //   index > -1 ? this.getPrnrList[index].text : "";

      // Set qlfrSenderEdiId, comEdiNm, comEdiId, comEdiIdKey before save
      // 2021.10.29 203728 SPKA-240 change follow comEdiIdKey, prEdiIdKey
      // index = this.senderEdiIdList.findIndex(
      //   (e) => e.id === this.formData.senderEdiIdKey
      // );
      // if (index > -1) {
      //   let data = this.senderEdiIdList[index];
      //   this.formData.qlfrSenderEdiId = data.srQlfr;
      // }

      // Set qlfrReceiverEdiId, receiverEdiIdKey before save
      // 2021.10.29 203728 SPKA-240 change follow comEdiIdKey, prEdiIdKey
      // index = this.receiverEdiIdList.findIndex(
      //   (e) => e.id === this.formData.receiverEdiIdKey
      // );
      // if (index > -1) {
      //   let data = this.receiverEdiIdList[index];
      //   this.formData.qlfrReceiverEdiId = data.srQlfr;
      //   // this.formData.receiverEdiIdKey = data.id;
      // }

      // 203737 03/26/2021 Set default srm
      // this.setDefaultSenderReceiver(this.mappers, this.formData.procDirCd);

      // 2021.10.7 203728 not use
      // await this.getRepttnDefautConverter();

      this.formData.procComList = this.arrProc;
      // 203737 03/29/2021 Save mapper contract in SPKA-54
      // this.getMapperContracts(this.mappers);
      // this.setQualifieContract(this.mapperContracts, this.formData.procDirCd);
      // console.log("Result ok", this.mappers, this.mapperContracts)
      // this.formData.mapper_contract = this.mapperContracts;
      // console.log("save dir", this.formData);

      // 2021.8.9 203728 need waiting when save
      // 2021.10.25 203728 SPKA-237 block click more
      if (this.onSave) return;
      showProgress();
      this.onSave = true;
      if (this.action === 'insert') {
        this.setDataSaveHistory();
        this.$store
          .dispatch('insertWorkflowGroup', this.formData)
          .then((res) => {
            hideProgress();
            this.onSave = false;
            this.formData.procId = `${res}`;
            this.formData.id = `${res}`;
            // 2021.9.10 203728 SPKA-208 add Test/Live indicator
            this.processType = 'Edit';
            this.title = 'Edit WorkFlow';
            // if(this.formData.applyStatus === 'S') this.clearDefaultDataAfterSave();
            this.$refs.RegisteredProcessSuccess.dialog = true;
          })
          .catch((err) => {
            hideProgress();
            this.onSave = false;
            this.checkDialogInfo = `Exception occured. Reason: ${err}`;
            this.checkDialogColor = 'error';
            this.$refs.AlertProcessSetup.dialog = true;
          });
      } else if (this.action === 'update') {
        this.setDataSaveHistory();
        this.$store
          .dispatch('updateWorkflowGroup', this.formData)
          .then(() => {
            hideProgress();
            this.onSave = false;
            // if(this.formData.applyStatus === 'S') this.clearDefaultDataAfterSave();
            this.$refs.ModifyProcessSuccess.dialog = true;
          })
          .catch((err) => {
            hideProgress();
            this.onSave = false;
            this.checkDialogInfo = `Exception occured. Reason: ${err}`;
            this.checkDialogColor = 'error';
            this.$refs.AlertProcessSetup.dialog = true;
          });
      }
    },
    clearDefaultDataAfterSave() {
      // 2021.8.27 After save clear data default
      let self = this;
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        if (comp.comTp == 'MAP') {
          let data = comp.listSrm;
          if (data.length > 0) {
            let chk = data.filter(
              (e) => e.sender && e.sender.id != '' && e.recipient && e.recipient.id != '',
            );
            if (chk.length === 1) {
              if (
                comp.listSrm[0].sender.id === self.getSenderIdDefault().id &&
                comp.listSrm[0].recipient.id === self.getReceiverIdDefault().id
              ) {
                comp.listSrm = [
                  {
                    id: '1',
                    sender: '',
                    recipient: '',
                    isUseDifferentEDI: 0,
                  },
                ];
              }
            } else if (chk.length === 0) {
              comp.listSrm = [
                {
                  id: '1',
                  sender: '',
                  recipient: '',
                  isUseDifferentEDI: 0,
                },
              ];
            }
          }
        }
      });
    },
    focusAddDirBtn() {
      setTimeout(() => {
        if (this.focusDirIcon) this.$refs['btnAddDir'].$el.focus();
      });
    },
    // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
    addDirInfo(item, nodeIndo) {
      let arrOutput =
        nodeIndo.outputs.output_1 === undefined ? [] : nodeIndo.outputs.output_1.connections;
      if (arrOutput.length > 0) {
        arrOutput.forEach((childItem) => {
          this.arrProc.forEach((node) => {
            if (node.nodeId === parseInt(childItem.node)) {
              item.comId = item.comId + '.' + node.nodeId;
            }
          });
        });
      }
      let arrInput =
        nodeIndo.inputs.input_1 === undefined ? [] : nodeIndo.inputs.input_1.connections;
      if (arrInput.length > 0) {
        arrInput.forEach((childItem) => {
          this.arrProc.forEach((node) => {
            if (node.nodeId === parseInt(childItem.node)) {
              item.comId = item.comId + '.' + node.nodeId;
            }
          });
        });
      }
      if (item.comId.charAt(item.comId.length - 1) === '.' || item.comId.charAt(0) === '.') {
        if (item.comId.charAt(item.comId.length - 1) === '.') {
          item.comId = item.comId.slice(0, -1);
        } else {
          item.comId = item.comId.substring(1);
        }
      }
    },
    getPartnerList(data) {
      this.prnrList = [];
      this.prnrList.push({ text: '*', value: '*' });

      // When company select != *
      if (this.formData.compId !== '*') {
        for (let i = 0; i < this.compList.length; i += 1) {
          if (this.compList[i].value === this.formData.compId) {
            this.prnrList.push(this.compList[i]);
          }
        }
        this.$store.dispatch('getPartnerUseList').then(() => {
          const tmpPrnrList = this.$store.getters.partnerUseList;
          for (let i = 0; i < tmpPrnrList.length; i += 1) {
            const tmpPrnr = tmpPrnrList[i];
            const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
            this.prnrList.push(tmp);
          }
        });
      }
    },
    async initialize() {
      // 2021.10.28 203728 add try catch
      let startTime = performance.now();
      try {
        this.$store.dispatch('getDbBrokerList');

        // 2021.10.26 203728 SPKA-224 return data not get store
        this.$store.dispatch('getCvtrGrpList');

        this.$store.dispatch('getFilterSelectBoxList');

        this.$store.dispatch('getUserComponentSelectBoxList');
        this.$store.dispatch('getWorkflowGroupSelectBoxList');

        // 2023.3.8 213979 SPKA-620 get data for DBA
        this.$store.dispatch('getDBAdapterList', {});

        // 2021.10.28 203728 wait
        await this.$store.dispatch('getCommunicationSelectBoxList');

        await this.$store.dispatch('getCompanyListSetup');
        // 04/28/2021 203737 SPKA-88 issue 46 Change company combo box in Add/Modify workflow
        let companyId;
        companyId = this.compList.filter((item) => item.value !== '*')[0].value;

        // 2021.11.4 203728 not found file in public/opensans_regular_macroman
        // console.log(this.options.dataValue);

        if (this.options.dataValue !== undefined) {
          this.isLoading = true;
          // 2021.10.28 203728 remove wait
          this.$store.dispatch('getWorkflowGroup', this.options.dataValue).then(async () => {
            const procInfo = this.$store.getters.workflowGroup;
            this.formData = procInfo;
            // this.formData.selSenderId = this.formData.selSenderEdiIdList;
            // this.formData.selReceiverId = this.formData.selReceiverEdiIdList;
            const params = {
              procId: this.options.dataValue,
              hash: this.$cookies.get('hash'),
            };

            // this.getPartnerList();
            // 2021.10.25 203728 SPKA-237 wait company EDI
            // await this.getSenderEdiId();
            // await this.getReceiverEdiId();
            this.$store.dispatch('getWorkflowGroupDtlList', params).then(() => {
              this.loadArrProc = this.$store.getters.workflowGroupDtlList;
              this.$nextTick(() => {
                this.updateComponent();
              });
            });
            this.action = 'update';

            if (this.options.isCopy) {
              this.action = 'insert';
              this.formData.procNm = '';
              // SPKA-49 2021.3.15 Disable Active when copy Workflow
              this.formData.actCd = 'N';
            }
          });
        } else {
          // 신규 입력일 경우에는 form 을 리셋함.
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
          this.action = 'insert';
          this.formData.compId = companyId;
          // 2021.5.18 203728 Choose new EDI apply only for Workflow
          // (this.selSenderId = { id: "" }),
          //   (this.selReceiverId = { id: "" }),
          //   this.getPartnerList();
          // this.getSenderEdiId();
          // this.getReceiverEdiId();
        }
        this.loadComponents();
      } catch (err) {
        // Close popup when click OK
        this.applyStatus = 'A';
        // Show error
        this.checkDialogInfo = `Open workflow group detail failed. Reason: ${err}`;
        this.checkDialogColor = 'error';
        this.$refs.AlertProcessSetup.dialog = true;
        this.isLoading = false;
      }
      // 2122.03.29 SPKA-421 Add spinner when loading Edit Workflow popup
      let endTime = performance.now();
      this.timeResponse = endTime - startTime;
      // let realTime = this.timeResponse > this.timeLoadComps ? this.timeResponse : this.timeLoadComps;
      setTimeout(() => {
        this.isLoading = false;
      }, this.timeResponse);
    },
    registerComponent(componentType, componentId, nodeInfo, mapperContract, useSrInMap) {
      const props = {
        comId: componentId,
        mapperContracts: mapperContract,
        listSender: this.listSender,
        listRecipient: this.listRecipient,
        listComId: this.arrProc,
        useSrInMap: useSrInMap,
        procDirCd: this.formData.procDirCd,
      };
      props.comId = componentId !== undefined ? componentId : '';

      const options = {
        store: store,
        i18n: i18n,
        vuetify: vuetify,
      };
      const procData = {
        comNm: '',
        comTp: componentType,
        comId: componentId,
        comInfo: '',
        nodeId: '',
        nodeInfo: nodeInfo,
      };
      // 2021.10.19 203728 SPKA-224 det data list
      switch (componentType) {
        case 'COM':
          procData.comNm = 'procComm';
          props.manage = this.authCompList.COM.manage;
          props.protocolList = this.protocolList;
          this.editor.registerNode(componentType, procComm, props, options);
          break;
        case 'MAP':
          procData.comNm = 'procMapper';
          props.manage = this.authCompList.MAP.manage;
          this.editor.registerNode(componentType, procMapper, props, options);
          break;
        case 'FLT':
          procData.comNm = 'procFilter';
          props.fltrTpCdList = this.fltrTpCdList;
          props.manage = this.authCompList.FLT.manage;
          this.editor.registerNode(componentType, procFilter, props, options);
          break;
        case 'CVT':
          procData.comNm = 'procConverter';
          props.cvtrTpCdList = this.cvtrTpCdList;
          props.manage = this.authCompList.CVT.manage;
          props.manageDBB = this.authCompList.DBB.manage;
          this.editor.registerNode(componentType, procConverter, props, options);
          break;
        case 'DIR':
          procData.comNm = 'procDir';
          this.editor.registerNode(componentType, procDir, props, options);
          break;
        case 'USR':
          procData.comNm = 'procUser';
          procData.comTp = 'USR';
          props.comTp = 'USR';
          props.setDisable = true;
          props.manage = this.authCompList.USR.manage;
          this.editor.registerNode(componentType, procUser, props, options);
          break;
        case 'DBA':
          procData.comNm = 'procDBAdapter';
          procData.nodeParent = nodeInfo.id;
          props.isDisable = true;
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
        case 'DBAC':
          procData.comNm = 'procDBAdapterChild';
          procData.comTp = 'DBAC';
          procData.nodeParent = nodeInfo.data.nodeParent;
          props.isDisable = true;
          props.comId = componentId;
          props.comTp = 'DBAC';
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
      }

      procData.nodeId = nodeInfo.id;
      this.arrProc.push(procData);
    },
    /* 203665 Load component saved in db */
    updateComponent() {
      /**
       * 2021.07.06 203737 SPKA-150 issue 98 Fix the no. 5. Start with DIR in "CLT_TestCase" sheet
       */
      if (this.loadArrProc.length > 0) {
        this.arrProc = [];
        let data = { drawflow: { Home: { data: {} } } };
        let number = 0;
        this.loadArrProc.map((e, i) => {
          let dta = JSON.parse(e.nodeInfo);
          data.drawflow.Home.data[dta.id] = dta;
          this.registerComponent(e.comTp, e.comId, dta, e.mapper_contract, e.use_sr_in_map);
          this.editor.addNodeImport(dta, this.editor.precanvas);
          if (number < dta.id) number = dta.id;
        });
        this.editor.nodeId = number + 1;
        this.editor.drawflow = data;
        this.$nextTick(() => {
          Object.values(data.drawflow.Home.data).map((item) => {
            this.editor.updateConnectionNodes('node-' + item.id);
          });
        });
      }
    },
    async alertProcSetupClose() {
      this.$refs.AlertProcessSetup.dialog = false;
      /**
       * 2021.08.19 203737 SPKA-183 Reagrding SAVE function: Only save data without close popup. Popup has to be reloaded after saving
       */
      this.closeWindow('btn-close');
      // if (this.applyStatus === "A") {
      //   this.closeWindow("btn-close");
      // } else {
      //   this.mappers = [];
      //   this.mapperContracts = [];
      //   this.apply_sts = "S";
      //   if (this.action === "update") {
      //     this.editor.clear();
      //     await this.reloadComponent();
      //   } else {
      //     this.action = "update";
      //     let procId = this.formData.id;
      //     this.options.dataValue = procId;
      //     this.editor.clear();
      //     await this.reloadComponent();
      //   }
      // }
    },
    // 2021.10.7 203728 SPKA-233 update only converter focus
    showWarningDialog(arrData) {
      let formData = {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
        cvtrTpCd: '',
        srcPttn: '',
        repPttn: '',
        repPttnInput: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
        nodeInfo: arrData.nodeId,
      };
      EventBus.$emit('updateFormData', formData);
      this.$refs.AlertConverterCheckbox.dialog = true;
    },
    async findMapIndex(route) {
      let resArrMapIndex = [];
      await Promise.all(
        route.map(async (e, i) => {
          if (e.class === 'MAP') {
            resArrMapIndex.push({
              index: i,
              id: e.id,
            });
          }
        }),
      );
      return resArrMapIndex;
    },
    async findMessage(id, routes, arrCheck) {
      let hehe = [];
      let arrMap = [];
      let obj = {};
      await Promise.all(
        routes.map(async (route, i) => {
          await Promise.all(
            route.map(async (e, i) => {
              if (e.id === id) {
                hehe.push(i);
                arrMap = [...arrMap, ...(await this.findMapIndex(route))];
                obj = {
                  cvtId: i,
                  arrMap: arrMap,
                };
                return obj;
              }
            }),
          );
        }),
      );
      return obj;
    },
    /* 203665 2020/01/05 workflow issue 18  */
    /* 203665 check SRM when choose converter comid="1"  */
    async checkForCreateConverter(arrData) {
      this.focusField = '';
      let sender = '';
      let receiver = '';
      let message = '';
      let replacePattern = '';
      let arrMap = [];
      let blankArrMap = [];
      let mapperIndex = 0;
      let self = this;

      let id = parseInt(arrData.nodeId.split('-').pop());
      // 2021.7.8 203728 remove out connect with SRM
      // 2021.7.12 203728 remove Maps connect in with SRM
      let checkLenOut = $(`.node_out_node-${id}`).length;
      let checkLenIn = $(`.node_in_node-${id}`).length;
      $(`.node_in_node-${id}`).each(function() {
        let arr = $(this)[0].className.baseVal.split(' ');
        let inId = arr[2].replace('node_out_node-', '');
        if (getType(inId) === 'MAP') self.editor.removeSingleConnection(inId, id, arr[3], arr[4]);
      });

      if (checkLenOut > 1) {
        $(`.node_out_node-${id}`).each(function() {
          let arr = $(this)[0].className.baseVal.split(' ');
          self.editor.removeSingleConnection(
            arr[2].replace('node_out_node-', ''),
            arr[1].replace('node_in_node-', ''),
            arr[3],
            arr[4],
          );
        });
      }

      let routes = await this.getRoutes(false);
      if (routes.length === 0) {
        this.messageValidate = self.$t('msg.processSetup.rule7');
        this.focusField = 'btnAddMap';
        this.showWarningDialog(arrData);
        return;
      } else {
        let resMapCvt = await this.findMessage(id, routes, arrMap);
        if (resMapCvt.arrMap.length === 0) {
          this.messageValidate = self.$t('msg.processSetup.rule7');
          this.focusField = 'btnAddMap';
          this.showWarningDialog(arrData);
          return;
        } else {
          let converterIndex = resMapCvt.cvtrId;
          let checkItem = '';
          if (resMapCvt.arrMap.length > 0) {
            mapperIndex = resMapCvt.arrMap.reduce((prev, curr) =>
              Math.abs(prev.index - converterIndex) <= Math.abs(curr.index - converterIndex)
                ? prev
                : curr,
            );
          }
          this.arrProc.forEach((item) => {
            if (item.nodeId === mapperIndex.id) {
              checkItem = item;
              return;
            }
          });
          if (checkItem.comInfo != '') {
            message = checkItem.comInfo.MESSAGENAME;
          } else {
            this.messageValidate = 'The Mapper is required to attach to the filename.';
            this.focusField = checkItem.nodeId;
            this.showWarningDialog(arrData);
            return;
          }
        }
      }

      // if (
      //   this.formData.selReceiverId == "" ||
      //   this.formData.selReceiverId == undefined
      // ) {
      //   replacePattern = "";
      //   this.messageValidate =
      //     "The Receiver is required to attach to the filename.";
      //   this.focusField = "selReceiverId";
      //   this.showWarningDialog(arrData);
      //   return;
      // } else {
      //   receiver = this.formData.selReceiverId;
      // }
      // if (
      //   this.formData.selSenderId == "" ||
      //   this.formData.selSenderId == undefined
      // ) {
      //   this.messageValidate =
      //     "The Sender is required to attach to the filename.";
      //   replacePattern = "";
      //   this.focusField = "selSenderId";
      //   this.showWarningDialog(arrData);
      //   return;
      // } else {
      //   sender = this.formData.selSenderId;
      // }
      // }
    },
    closeValidateDialog() {
      this.$refs.AlertConverterCheckbox.dialog = false;
      // 2021.7.8 203728 don't focus if CVT connecting multi Mappers => SRM
      if (!this.focusDirIcon) return;
      if (isNaN(this.focusField)) {
        if (this.focusField == 'btnAddMap') {
          setTimeout(() => {
            this.$refs[this.focusField].$el.focus();
          });
        } else {
          setTimeout(() => {
            this.$refs[this.focusField].focus();
          });
        }
      } else {
        setTimeout(() => {
          EventBus.$emit('focusMap', this.focusField);
        });
      }
    },
    collapse(val) {
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        let tp = comp.comTp;
        if (tp != 'DIR') comp.collapse(val);
      });
    },
    // 203737 03/29/2021 Set info contract in SPKA-54
    setInfoContract(data) {
      let isInclude = false;
      if (this.mappers.length == 0) {
        this.mappers.push(data);
      } else {
        for (let i = 0; i < this.mappers.length; i++) {
          if (this.mappers[i].mapperId == data.mapperId) {
            isInclude = true;
            this.mappers[i].info = data.info;
            break;
          }
        }
        if (!isInclude) {
          this.mappers.push(data);
        }
      }
    },
    // 203737 03/29/2021 Get info mapper contract in SPKA-54
    getMapperContracts(data) {
      let obj, arr, isEquals, arrSender, arrReceiver, lenMap;
      for (let i = 0; i < data.length; i++) {
        arr = data[i].info;
        if (arr[0]) {
          obj = {
            mapper_id: '',
            sender_id: [],
            receiver_id: [],
            sequence: 1,
            use_sr_in_map: arr[0].isUseDifferentEDI,
            sender_nm: [],
            receiver_nm: [],
            sender_qual: [],
            receiver_qual: [],
          };
          for (let j = 0; j < arr.length; j++) {
            obj.sender_id.push(arr[j].sender.id);
            obj.receiver_id.push(arr[j].recipient.id);
            obj.sender_nm.push(arr[j].sender.srId);
            obj.receiver_nm.push(arr[j].recipient.srId);
          }
          obj.mapper_id = data[i].mapperId;
          if (this.mapperContracts.length == 0) {
            this.mapperContracts.push(obj);
          } else {
            isEquals = false;
            for (let j = 0; j < this.mapperContracts.length; j++) {
              arrSender = this.mapperContracts[j].sender_id;
              arrReceiver = this.mapperContracts[j].receiver_id;
              if (
                JSON.stringify(obj.sender_id) === JSON.stringify(arrSender) &&
                JSON.stringify(obj.receiver_id) === JSON.stringify(arrReceiver)
              ) {
                isEquals = true;
                obj.sequence = this.mapperContracts[j].sequence;
                this.mapperContracts.push(obj);
                break;
              }
            }
            this.mapperContracts.sort(function(a, b) {
              return a.sequence - b.sequence;
            });
            if (!isEquals) {
              lenMap = this.mapperContracts.length;
              obj.sequence = this.mapperContracts[lenMap - 1].sequence + 1;
              this.mapperContracts.push(obj);
            }
          }
        }
      }
    },
    // 203737 03/29/2021 Set default Sender and Receiver in SPKA-54
    setDefaultSenderReceiver(mappers, procDirCd) {
      let item;
      for (let i = 0; i < mappers.length; i++) {
        item = mappers[i].info;
        if (
          item.length === 1 &&
          (item[0].sender === '' || item[0].recipient === '') &&
          item[0].isUseDifferentEDI === 0
        ) {
          item[0].sender = this.getSenderIdDefault();
          item[0].recipient = this.getReceiverIdDefault();
        }
      }
    },
    // 203737 03/29/2021 Remove map after change select map in SPKA-54
    removeMapAfterChangeSelectMap(data) {
      // 203737 04/22/2021 SPKA-79 Issue-40 The copy source mapping id goes into the contract of the JSON when make a setup by copying
      this.$nextTick((x) => {
        if (this.action === 'insert' && !this.options.isCopy) {
          let oldInfo;
          for (let i = 0; i < this.mappers.length; i++) {
            if (this.mappers[i].mapperId === data.oldMapperId) {
              oldInfo = this.mappers[i].info;
            }
          }
          this.mappers = this.mappers.filter((item) => item.mapperId !== data.oldMapperId);

          this.$nextTick((x) => {
            for (let i = 0; i < this.mappers.length; i++) {
              if (this.mappers[i].mapperId === data.newMapperId && oldInfo) {
                this.mappers[i].info = oldInfo;
              }
            }
          });
        } else {
          for (let i = 0; i < this.mappers.length; i++) {
            if (this.mappers[i].mapperId === data.oldMapperId) {
              this.mappers[i].mapperId = data.newMapperId;
            }
          }
        }
      });
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    sendMessage(type) {
      let message = {
        message: type,
      };
      window.postMessage(message, '*');
    },
    // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
    openFolderList(data) {
      this.nodeDir = data.nodeId;
      // 05/31/2021 203737 SPKA-113 issue 27 Focus folder selected
      this.foldId = data.foldId;
      let type = 'folderList';
      let item = {
        ROWID: 0,
        data,
      };
      let indexArrDialog = this.findDialog('folderList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    queryLeftList() {
      this.leftItems.data[0].USER_ID = this.$cookies.get('user-id');
      this.$store.dispatch('queryFolderList', this.leftItems);
    },
    selectPathFolder(data) {
      EventBus.$emit('updatePathFolder', data);
    },
    getMessageTypeMapper(id) {
      let message = '';
      let info = this.getNodeData(id);
      let nodeIdMapper = info.outputs.output_1.connections[0].node;
      this.arrProc.map((item) => {
        if (item.nodeId == nodeIdMapper) {
          message = item.comInfo.MESSAGENAME;
        }
      });
      return message;
    },
    setDataSaveHistory() {
      this.formData.currVersionNo = this.currVersionNo * 10;
      this.formData.applyCmt = this.applyCmt;
    },
    openProcessApplyHistory(item) {
      let type = 'ProcessApplyHistory';
      item.ROWID = 0;
      let indexArrDialog = this.findDialog('ProcessApplyHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    setCommentHistory(contentComment) {
      this.applyCmt = contentComment;
      this.saveDataToServer();
    },
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        let self = this;
        if (updatedState?.COM) {
          this.$store.dispatch('getCommunicationSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.communicationChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'COM') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.selectComm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.communicationRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.communicationRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.FLT) {
          this.$store.dispatch('getFilterSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.filterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'FLT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.selectFilter();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.filterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.filterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.CVT) {
          this.$store.dispatch('getCvtrGrpList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.converterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'CVT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.selectConverter();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.converterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.converterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.DBA) {
          this.$store.dispatch('getDBAdapterList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.dbAdapterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'DBA') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                } else if (comp.comTp == 'DBAC') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      self.delNodeComponent(comp.nodeId);
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.USR) {
          this.$store.dispatch('getUserComponentSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.userComponentChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'USR') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.selectUser();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.userRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.userRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.MAP) {
          let masterSearchItems = {
            header: ['ADMIN_YN', 'CUST_ID'],
            data: [
              {
                ADMIN_YN: this.$cookies.get('user-admin-yn'),
                CUST_ID: this.$cookies.get('comp-id'),
              },
            ],
          };
          this.$store.dispatch('map/queryMapListByProcSetup', masterSearchItems).then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.mapChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'MAP') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.selectMap();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.mapperRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.mapperRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.COMP) {
          this.$store.dispatch('getCompanyListSetup').then(() => {
            const dataChange = self.$store.getters.companyChange;
            if (Object.keys(dataChange).length > 0 && dataChange.remove.length > 0) {
              let index = dataChange.remove.findIndex((e) => e.value == this.formData.compId);
              if (index !== -1) {
                this.formData.compId = self.compList.filter((item) => item.value !== '*')[0].value;
              }
            }
          });
        } else if (updatedState?.PRNR) {
          const companyId = this.compList.filter((item) => item.value !== '*')[0].value;
          this.$store.dispatch('getPartnerUseList').then(() => {
            const dataChange = this.$store.getters.partnerChange;
            if (Object.keys(dataChange).length > 0) {
              if (dataChange.new.length > 0) {
                for (let i = 0; i < dataChange.new.length; i += 1) {
                  const tmpPrnr = dataChange.new[i];
                  const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
                  this.prnrList.push(tmp);
                }
              } else if (dataChange.update.length > 0) {
                let indexSender = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                }
                let indexReceiver = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                }
                for (let i = 0; i < dataChange.update.length; i += 1) {
                  const tmpPrnr = dataChange.update[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
                    this.prnrList.splice(index, 1, tmp);
                  }
                }
              } else if (dataChange.remove.length > 0) {
                let indexSender = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                }
                let indexReceiver = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                }
                for (let i = 0; i < dataChange.remove.length; i += 1) {
                  const tmpPrnr = dataChange.remove[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    this.prnrList.splice(index, 1);
                  }
                }
              }
            }
          });
        }
      }
    });
  },
};
</script>

<style></style>
